/* eslint-disable */
import { getUploadLivraisonErrorMessage } from "../../../../utils/uploadLivraisonError";
import React, { useState, useEffect, useRef } from "react";
import { setDoc, doc, updateDoc, writeBatch } from "firebase/firestore";
import { useDispatch } from "react-redux";
import { updateProduct } from "../../../../redux/products/products";
import { fetchStore } from "../../../../redux/store/store";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { db } from "../../../../firebase";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import usePagination from "../../../helper/paginate/Pagination";
import "./DataTableDemo.css";
import { Link, useNavigate } from "react-router-dom";
import { ComponentToPrint } from "./ComponentToPrint";
import { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import { fetchDate } from "../../../../utils/globleFunc";
import { datat } from "./data";
import { CommuneZimou } from "./communeZimou";
import { citeMorooco } from "./citeMorooco";
import { states_lby } from "./statesLibye";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import "moment/locale/ar";
import "moment/locale/fr";
import apicache from "../../../../components/clearCach/clear";
import { PDFDocument } from "pdf-lib";
import html2pdf from "html2pdf.js";
import { Menu, Dropdown, message, Input } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import communesMaystro from "./communesMaystro.json";
import wilayaMaystro from "./wilayaMaystro.json";
import wilayaMylerzzz from "./wilayaMylerz.json";
import { useTranslation } from "react-i18next";
import { Edit } from "lucide-react";
import useIsDark from "../../../../utils/isDark";
import DeskModal from "./DeskModal";
import { GoogleSheetButtons } from "./googleSheetButton";
import { territoriesData } from "./zrExpressV2/territories";
import workerAPI from "../../../../api/worker/worker_service";
import PhoneActionMenu from "../../../PhoneActionMenu";
import { changeShip as runChangeShip } from "../../../orders/DataTableTemplatingDemo/changeShip";
import { fetchAccount } from "../../../../redux/account/account";
import { consumeSubscriptionToken } from "../../../../utils/subscriptionPayment";
const DataTableTemplatingDemo = ({
  filter,
  orders,
  allOrders = [],
  pageSize,
  setData,
  setLgShow,
  onSave,
  confirmersCount = 0,
}) => {
  console.log("DataTableTemplatingDemo rendered with orders:", orders);
  const dispatch = useDispatch();
  const url =
    "https://import-export-orders-as6qwsolmq-ew.a.run.app/api/delivery/orders/";
  const url1 = "https://backend.foorweb.store/api/UploadLivraison";
  const url4 = "https://app.noest-dz.com/api/public/create/order";
  const url5 = "https://backend.foorweb.store/api/UploadLivraison";
  const url6 = "https://backend.foorweb.store/api/UploadLivraison";
  const worker = useSelector((state) => state.workerReducer);
  const currentWorkerId = worker?.id || worker?.user || worker?.uid;
  const currentWorkerName =
    worker?.name || worker?.fullName || worker?.username || worker?.email;
  const isConfirmer = worker?.role === "confirmer";
  console.log("Current confirmersCount:", confirmersCount);
  const hasMultipleConfirmers = confirmersCount >= 2;
  console.log("hasMultipleConfirmers:", hasMultipleConfirmers);
  const permissions = worker?.permissions || {};
  const canViewOrders = permissions["orders.view"] === true;
  const canViewStore = permissions["store.view"] === true;
  const canEditOrders = permissions["orders.update"] === true;
  const canDeleteOrders = permissions["orders.delete"] === true;
  const canEditStore = permissions["store.update"] === true;
  const canAddOrder = permissions["orders.create"] === true;
  const productss = useSelector((state) => state.ProductsReducer);
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const [expandedRows, setExpandedRows] = useState(null);
  const productdata = useSelector((state) => state.ProductsReducer);
  const isDark = useIsDark();
  const [bluck, setBluck] = useState("");
  const [deleveryCompany, setDeleveryCompany] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  let [page, setPage] = useState(1);
  const PER_PAGE = pageSize;
  const count = Math.ceil(orders.length / PER_PAGE);
  const _DATA = usePagination(orders, PER_PAGE);
  const products = useSelector((state) => state.ProductsReducer);
  const [showSubmenus, setShowSubmenus] = useState({});

  const [noestModalOpen, setNoestModalOpen] = useState(false);
  const [noestSelectedDeskCode, setNoestSelectedDeskCode] = useState(null);
  const [noestPendingData, setNoestPendingData] = useState(null);
  const [noestPendingResolve, setNoestPendingResolve] = useState(null);
  const [noestPendingReject, setNoestPendingReject] = useState(null);

  const [yalidineModalOpen, setYalidineModalOpen] = useState(false);
  const [yalidineSelectedDeskCode, setYalidineSelectedDeskCode] =
    useState(null);
  const [yalidinePendingData, setYalidinePendingData] = useState(null);
  const [yalidinePendingResolve, setYalidinePendingResolve] = useState(null);
  const [yalidinePendingReject, setYalidinePendingReject] = useState(null);

  const [isMultiple, setIsMultiple] = useState(false);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const getOrdersScope = () =>
    Array.isArray(allOrders) && allOrders.length ? allOrders : orders;

  const hasPendingAssignedOrder = (exceptOrderId = null) =>
    getOrdersScope().some(
      (order) =>
        order?.id !== exceptOrderId &&
        order?.assignedConfirmerId === currentWorkerId &&
        order?.deleveryStatus === "1",
    );

  const showPendingOrderAlert = () => {
    Swal.fire({
      icon: "warning",
      title: t("orders.datatable_templating_demo.warning") || t("Products.modalAdd.submitduplicateAlert"),
      text:
        t("orders.datatable_templating_demo.change_status_first") ||
        t("ui.finishOpenOrder"),
      confirmButtonText: t("orderDetails.alerts.ok") || t("ship.ok"),
    });
  };
  const [errorMessage, setErrorMessage] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();

  const shouldIgnoreIsValid = (order) => {
    const status = String(order?.deleveryStatus || "");
    return status === "3" || status === "6";
  };

  const shouldShowLockedContent = (order) =>
    Boolean(order?.isValid) && !shouldIgnoreIsValid(order);


  const normalizePhoneForDuplicate = (phone) => {
    const digitsOnly = String(phone || "").replace(/\D/g, "");
    if (!digitsOnly) return "";
    return digitsOnly.slice(-9);
  };

  const getOrderDayKey = (order) => {
    const raw = order?.timeStamp;
    if (!raw) return "";

    let dateValue;
    if (raw?._seconds) {
      dateValue = new Date(raw._seconds * 1000);
    } else if (raw?.seconds) {
      dateValue = new Date(raw.seconds * 1000);
    } else {
      dateValue = new Date(raw);
    }

    if (Number.isNaN(dateValue.getTime())) return "";

    const year = dateValue.getFullYear();
    const month = String(dateValue.getMonth() + 1).padStart(2, "0");
    const day = String(dateValue.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const autoMarkDuplicateOrders = async () => {
      if (!Array.isArray(orders) || orders.length < 2) return;

      const groupedOrders = new Map();

      orders.forEach((order) => {
        if (String(order?.deleveryStatus) === "20") return;

        const phoneKey = normalizePhoneForDuplicate(order?.phone);
        const dayKey = getOrderDayKey(order);
        if (!phoneKey || !dayKey) return;

        const groupKey = `${phoneKey}|${dayKey}`;
        if (!groupedOrders.has(groupKey)) {
          groupedOrders.set(groupKey, []);
        }
        groupedOrders.get(groupKey).push(order);
      });

      const getOrderTimestampMs = (order) => {
        const raw = order?.timeStamp;
        if (raw?.seconds) return raw.seconds * 1000;
        const parsed = new Date(raw).getTime();
        return Number.isNaN(parsed) ? Number.MAX_SAFE_INTEGER : parsed;
      };

      const hasAlreadyBeenAutoMarkedDuplicate = (order) =>
        Array.isArray(order?.statusTimeline) &&
        order.statusTimeline.some(
          (entry) =>
            String(entry?.status) === "6-2" &&
            String(entry?.ownby || "").toLowerCase() === "automatique",
        );

      const duplicatesToUpdate = [];
      groupedOrders.forEach((group) => {
        if (group.length >= 2) {
          const orderedGroup = [...group].sort(
            (left, right) => getOrderTimestampMs(left) - getOrderTimestampMs(right),
          );

          orderedGroup.slice(1).forEach((order) => {
            if (
              String(order?.deleveryStatus) !== "6-2" &&
              !hasAlreadyBeenAutoMarkedDuplicate(order)
            ) {
              duplicatesToUpdate.push(order);
            }
          });
        }
      });

      if (duplicatesToUpdate.length === 0) return;

      try {
        const batch = writeBatch(db);
        const now = new Date();

        duplicatesToUpdate.forEach((order) => {
          const nextTimeline = [
            ...(order.statusTimeline || []),
            { status: "6-2", timestamp: now, ownby: "Automatique" },
          ];

          const updatedOrder = {
            ...order,
            deleveryStatus: "6-2",
            statusTimeline: nextTimeline,
            ownby: "Automatique",
          };

          batch.set(doc(db, "orders", order.id), updatedOrder);
        });

        await batch.commit();

        const updatedById = new Map(
          duplicatesToUpdate.map((order) => {
            const nextTimeline = [
              ...(order.statusTimeline || []),
              { status: "6-2", timestamp: now, ownby: "Automatique" },
            ];

            return [
              order.id,
              {
                ...order,
                deleveryStatus: "6-2",
                statusTimeline: nextTimeline,
                ownby: "Automatique",
              },
            ];
          }),
        );

        updatedById.forEach((updatedOrder, orderId) => {
          onStatusChange(orderId, updatedOrder);
        });

        dispatch(
          fetchOrders(
            ordersState.map((order) => updatedById.get(order.id) || order),
          ),
        );
      } catch (error) {
        console.error("Erreur auto-duplicate (6-2):", error);
      }
    };

    autoMarkDuplicateOrders();
  }, [orders, ordersState, dispatch, onStatusChange]);

  const SYNC_INTERVAL = 30 * 60 * 1000; // 30 minutes

  // const runSync = async (forced = false) => {
  //   const lastSync = localStorage.getItem("ecotrack_last_sync");
  //   const now = Date.now();

  //   if (forced || !lastSync || now - parseInt(lastSync) > SYNC_INTERVAL) {
  //     console.log("⏳ Synchronisation en cours...");
  //     await EchotrackOrders(); // récupère depuis l'API et stocke dans localStorage
  //     localStorage.setItem("ecotrack_last_sync", now.toString());
  //     await updateStatusesFromLocalStorage(); // lit localStorage et met à jour Firebase
  //   } else {
  //     console.log("⏹️ Synchronisation ignorée (encore récente)");
  //   }
  // };

  // useEffect(() => {
  //   runSync();
  // }, []);

  const generateFileName = () => {
    // الحصول على التاريخ والوقت الحالي
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // الشهر يبدأ من 0
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");

    // بناء اسم الملف مع التاريخ والوقت
    return `ordersfoorweb_${year}-${month}-${day}_${hours}:${minutes}.csv`;
  };

  const EchotrackOrders = async () => {
    let page = 1;
    let lastPage = 1;
    const allOrders = [];

    const endDate = new Date(); // aujourd’hui
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 7); // 7 jours en arrière
    const formatDate = (date) => date.toISOString().split("T")[0];
    const startStr = formatDate(startDate);
    const endStr = formatDate(endDate);

    do {
      const response = await fetch(
        `${store.Uecotrack}/api/v1/get/orders?page=${page}&start_date=${startStr}&end_date=${endStr}`,
        {
          headers: {
            Authorization: `Bearer ${store.Ecotrack}`,
          },
        },
      );

      const result = await response.json();
      allOrders.push(...result.data);

      lastPage = result.last_page;
      page++;
    } while (page <= lastPage);
    localStorage.setItem("ecotrack_orders", JSON.stringify(allOrders));
    localStorage.setItem("ecotrack_last_sync", Date.now().toString());
  };

  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();

    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000); // Fetch date every minute
    return () => clearInterval(interval); // Cleanup function
  }, []);
  useEffect(() => {
    // Vérifier les commandes toutes les minutes
    const interval = setInterval(() => {
      const now = new Date();
      // Ne vérifier que vers minuit pour économiser des ressources
      if (now.getHours() === 0 && now.getMinutes() <= 1) {
        orders.forEach((order) => {
          checkAndUpdateStatusAtMidnight(order);
        });
      }
    }, 3600000); // Vérifier toutes les minutes

    return () => clearInterval(interval);
  }, [orders]);

  const statusBodyTemplate = (rowData) => {
    let color = "#fff";
    if (rowData.deleveryStatus === "1") {
      color = "#fff";
    }
    if (rowData.deleveryStatus === "2") {
      color = "#e1a626";
    }
    if (rowData.deleveryStatus === "3") {
      color = "#25c7bf";
    }
    if (rowData.deleveryStatus === "4") {
      color = "#8c5fa5";
    }
    if (rowData.deleveryStatus === "5") {
      color = "#49a688";
    }
    if (rowData.deleveryStatus === "6") {
      color = "#e87778";
    }
    if (rowData.deleveryStatus === "11-1") {
      color = "#0074D9";
    }
    if (rowData.deleveryStatus === "11-2") {
      color = "#D3D3D9";
    }
    if (rowData.deleveryStatus === "11-3") {
      color = "#e1a626";
    }
    if (rowData.deleveryStatus === "11-4") {
      color = "#000000";
    }
    if (rowData.deleveryStatus === "11-5") {
      color = "#800080";
    }
    if (rowData.deleveryStatus === "11") {
      color = "#e1a626";
    }
    return (
      <Form.Select
        aria-label={t("ship.order_status")}
        className={
          rowData.deleveryStatus === "1" ? `text-dark n-status` : `text-white `
        }
        value={rowData.deleveryStatus}
        onChange={(e) => {
          changeStatus(rowData, e.target.value);
        }}
        style={{
          backgroundColor: `${color}`,
          zIndex: "9000",
        }}
      >
        {rowData.deleveryStatus !== "5" && (
          <>
            <option value="1">
              {t("orders.datatable_templating_demo.new")}
            </option>
            <option value="3">
              {t("orders.datatable_templating_demo.confirmed")}
            </option>
            <option value="9">
              {t("orders.datatable_templating_demo.confirmed_by_customer")}
            </option>
            <option value="11-2">
              {t("orders.datatable_templating_demo.no_response_to_call")}
            </option>
            <option value="11-3">
              {t("orders.datatable_templating_demo.postponed")}
            </option>
            {rowData.deleveryStatus !== "5" && (
              <option value="6">
                {t("orders.datatable_templating_demo.cancelled")}
              </option>
            )}
            <option value="11-5">
              {t("orders.datatable_templating_demo.cancelled_by_customer")}
            </option>
            <option value="11-1">
              {t("orders.datatable_templating_demo.awaiting_customer_contact")}
            </option>
            <option value="11-4">
              {t("orders.datatable_templating_demo.line_busy")}
            </option>
            <option value="4">
              {t("orders.datatable_templating_demo.with_delivery_company")}
            </option>
          </>
        )}
        <option value="5">
          {t("orders.datatable_templating_demo.completed")}
        </option>
      </Form.Select>
    );
  };

  //fonction pour maystro
  function convertirCommuneArabeVersFrancais(communeArabe, w, datat) {
    if (!communeArabe || typeof communeArabe !== "string") {
      throw new Error(
        "Le nom de la commune en arabe doit être une chaîne de caractères",
      );
    }

    if (!Array.isArray(datat)) {
      throw new Error("Les données doivent être un tableau");
    }
    const communeTrouvee = datat.find(
      (item) =>
        item.commune_name?.trim() === communeArabe.trim() &&
        Number(item.wilaya_code) === Number(w),
    );

    if (!communeTrouvee) {
      console.warn(
        `Aucune correspondance trouvée pour la commune: ${communeArabe}`,
      );
      return null;
    }

    return communeTrouvee.commune_name_ascii;
  }

  const paidBodyTemplate = (rowData) => {
    let color = "#474747";
    if (rowData.paid === "0") {
      color = "#474747";
    }
    if (rowData.paid === "1") {
      color = "#19a886";
    }
    return (
      <Form.Select
        aria-label={t("ship.order_status")}
        value={rowData.paid}
        onChange={(e) => {
          changepaid(rowData, e.target.value);
        }}
        className={`text-white`}
        style={{ backgroundColor: `${color}` }}
      >
        <option value="0">
          {t("orders.datatable_templating_demo.not_paid")}
        </option>
        <option value="1">{t("orders.datatable_templating_demo.paid")}</option>
      </Form.Select>
    );
  };

  moment.defineLocale("fr-num", {
    parentLocale: "fr",
    months: moment.locales("fr").months,
    monthsShort: moment.locales("fr").monthsShort,
    weekdays: moment.locales("fr").weekdays,
    weekdaysShort: moment.locales("fr").weekdaysShort,
    weekdaysMin: moment.locales("fr").weekdaysMin,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm",
    },
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "quelques secondes",
      ss: "%d secondes",
      m: "une minute",
      mm: "%d minutes",
      h: "une heure",
      hh: "%d heures",
      d: "un jour",
      dd: "%d jours",
      M: "un mois",
      MM: "%d mois",
      y: "une année",
      yy: "%d années",
    },
    preparse: function (string) {
      return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
        return "٠١٢٣٤٥٦٧٨٩".indexOf(match);
      });
    },
  });

  useEffect(() => {
    if (errorMessage) {
      Swal.fire({
        title: t("orders.datatable_templating_demo.error"),
        text: errorMessage,
        icon: "error",
        confirmButtonText: t("orders.datatable_templating_demo.okay"),
      }).then(() => {
        setErrorMessage("");
      });
    }
  }, [errorMessage]);
  // Fonction pour envoyer à Noest avec bureau
  const sendToNoestWithDesk = async (
    data,
    productDetails,
    adresse,
    selectedDeskCode,
  ) => {
    try {
      const response = await axios.post(
        "https://app.noest-dz.com/api/public/create/order",
        {
          station_code: selectedDeskCode,
          user_guid: store.Userguid,
          api_token: store.ApitokenNord,
          type_id: 1,
          stop_desk: 1,
          produit: productDetails,
          client: data.name,
          phone: data.phone,
          quantite: `${data.qty}`,
          adresse: adresse,
          wilaya_id:
            datat.find((d) => d.wilaya_name === data.state)?.wilaya_code ?? "",
          commune:
            datat.find((d) => d.commune_name === data.commune)
              ?.commune_name_ascii ?? "",
          montant: data.total,
          NoteClient: data.note,
          Remboursement: 0,
          poids: "0",
        },
      );

      const tracking = response?.data?.tracking;
      const updatedData = {
        ...data,
        deleveryStatus: "4",
        DC: status,
        tracking: tracking,
        selectedDesk: selectedDeskCode,
      };
      await workerAPI.updateOrder(data.id, updatedData);
      onSave(updatedData);
      return { success: true, tracking };
    } catch (error) {
      throw new Error(
        error.response?.data?.error || "Erreur lors de l'envoi de la commande",
      );
    }
  };

  const sendToNoestNormal = async (data, productDetails, adresse) => {
    try {
      const orderData = {
        user_guid: `${store.Userguid}`,
        api_token: `${store.ApitokenNord}`,
        type_id: 1,
        stop_desk: 0,
        produit: `${productDetails}`,
        client: data.name,
        phone: data.phone,
        quantite: `${data.qty}`,
        adresse: adresse,
        wilaya_id: datat.filter((d) => d.wilaya_name === data.state)[0]
          .wilaya_code,
        commune: datat.filter((d) => d.commune_name === data.commune)[0]
          .commune_name_ascii,
        montant: data.total,
        NoteClient: data.note,
        Remboursement: 0,
        poids: `0`,
      };

      const response = await axios.post(
        "https://app.noest-dz.com/api/public/create/order",
        orderData,
      );
      const tracking = response?.data?.tracking;
      const updatedData = {
        ...data,
        deleveryStatus: "4",
        DC: status,
        tracking: tracking,
      };
      await workerAPI.updateOrder(data.id, updatedData);
      onSave(updatedData);

      return { success: true, tracking };
    } catch (error) {
      throw new Error(
        error.response?.data?.error || "Erreur lors de l'envoi de la commande",
      );
    }
  };

  const sendToYalidineWithDesk = async (
    data,
    productDetails,
    adresse,
    selectedDeskCode,
  ) => {
    try {
      const postData = {
        keyword: "yalidine",
        data: [
          {
            order_id: "MyFirstOrder",
            center_code: selectedDeskCode,
            firstname: ".",
            familyname: data.name,
            contact_phone: data.phone,
            address: adresse,
            to_commune_name: datat.filter(
              (d) => d.commune_name === data.commune,
            )[0].commune_name_ascii,
            to_wilaya_name: datat.filter((d) => d.wilaya_name === data.state)[0]
              .wilaya_name_ascii,
            product_list: `${productDetails}`,
            price: data.total,
            do_insurance: false,
            declared_value: data.total,
            freeshipping: data.deliveryPrice == 0 ? true : false,
            is_stopdesk: data.stopdeskDelivery ? data.stopdeskDelivery : false,
            stopdesk_id: 0,
            has_exchange: false,
            product_to_collect: null,
          },
        ],
      };
      axios
        .post(url5, postData, {
          headers: {
            "yalidine-id": store.Yalidineid,
            "yalidine-token": store.Yalidinetoken,
            "Content-Type": "application/json",
          },
        })
        .then(async (response) => {
          const tracking = response.data?.data?.MyFirstOrder.tracking;
          const updatedData = {
            ...data,
            deleveryStatus: "4",
            tracking: tracking,
            DC: status,
          };
          await workerAPI.updateOrder(data.id, updatedData);
          onSave(updatedData);
          return { success: true, tracking };
        })
        .catch((error) => {
          console.error("Error in Axios request:", error);
          console.error("Error in Axios request:", error.message);
          setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.response.data.error));
        });

      return { success: true, tracking };
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Erreur lors de l'envoi vers Yalidine",
      );
    }
  };

  // Envoi vers Yalidine normal (à domicile)
  const sendToYalidineNormal = async (data, productDetails, adresse) => {
    const postData = {
      keyword: "yalidine",
      data: [
        {
          order_id: "MyFirstOrder",
          firstname: ".",
          familyname: data.name,
          contact_phone: data.phone,
          address: adresse,
          to_commune_name: datat.filter(
            (d) => d.commune_name === data.commune,
          )[0].commune_name_ascii,
          to_wilaya_name: datat.filter((d) => d.wilaya_name === data.state)[0]
            .wilaya_name_ascii,
          product_list: `${productDetails}`,
          price: data.total,
          do_insurance: false,
          declared_value: data.total,
          freeshipping: data.deliveryPrice == 0 ? true : false,
          is_stopdesk: data.stopdeskDelivery ? data.stopdeskDelivery : false,
          stopdesk_id: 0,
          has_exchange: false,
          product_to_collect: null,
        },
      ],
    };

    axios
      .post(url5, postData, {
        headers: {
          "yalidine-id": store.Yalidineid,
          "yalidine-token": store.Yalidinetoken,
          "Content-Type": "application/json",
        },
      })
      .then(async (response) => {
        const tracking = response.data?.data?.MyFirstOrder.tracking;
        const updatedData = {
          ...data,
          deleveryStatus: "4",
          tracking: tracking,
          DC: "5",
        };
        await workerAPI.updateOrder(data.id, updatedData);
        onSave(updatedData);
        return { success: true, tracking };
      })
      .catch((error) => {
        console.error("Error in Axios request:", error);
        console.error("Error in Axios request:", error.message);
        setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.response.data.error));
      });
  };

  const [pendingResolve, setPendingResolve] = useState(null);
  const [pendingReject, setPendingReject] = useState(null);

  const handleNoestDeskSelected = async (selectedDeskCode) => {
    if (noestPendingData && noestPendingResolve) {
      try {
        const result = await sendToNoestWithDesk(
          noestPendingData,
          "",
          noestPendingData.address || ".",
          selectedDeskCode,
        );
        noestPendingResolve(result);
      } catch (error) {
        noestPendingReject(error);
      } finally {
        setNoestPendingData(null);
        setNoestPendingResolve(null);
        setNoestPendingReject(null);
      }
    }
    setNoestModalOpen(false);
  };

  const handleNoestModalClose = () => {
    if (noestPendingReject) {
      // noestPendingReject(new Error("Sélection annulée"));
      setNoestPendingData(null);
      setNoestPendingResolve(null);
      setNoestPendingReject(null);
    }
    setNoestModalOpen(false);
  };

  const handleYalidineDeskSelected = async (selectedDeskCode) => {
    if (yalidinePendingData && yalidinePendingResolve) {
      try {
        const result = await sendToYalidineWithDesk(
          yalidinePendingData,
          "",
          yalidinePendingData.address || ".",
          selectedDeskCode,
        );
        yalidinePendingResolve(result);
      } catch (error) {
        yalidinePendingReject(error);
      } finally {
        setYalidinePendingData(null);
        setYalidinePendingResolve(null);
        setYalidinePendingReject(null);
      }
    }
    setYalidineModalOpen(false);
  };

  const handleYalidineModalClose = () => {
    if (yalidinePendingReject) {
      // yalidinePendingReject(new Error("Sélection annulée"));
      setYalidinePendingData(null);
      setYalidinePendingResolve(null);
      setYalidinePendingReject(null);
    }
    setYalidineModalOpen(false);
  };

  const dateBodyTemplate = (rowData) => {
    let timestamp;

    if (rowData.timeStamp?._seconds) {
      timestamp = rowData.timeStamp._seconds * 1000;
    } else if (rowData.timeStamp?.seconds) {
      timestamp = rowData.timeStamp.seconds * 1000;
    } else if (typeof rowData.timeStamp === "number") {
      timestamp = rowData.timeStamp;
    } else {
      return <span>-</span>;
    }

    const now = Date.now();
    const date = moment(timestamp).locale("fr-num");
    const diff = now - timestamp;

    if (diff < 60000) {
      // Moins d'une minute
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 1000)}{" "}
          {t("orders.datatable_templating_demo.seconds")}
        </span>
      );
    } else if (diff < 3600000) {
      // Moins d'une heure
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 60000)}{" "}
          {t("orders.datatable_templating_demo.minutes")}
        </span>
      );
    } else if (diff < 86400000) {
      // Moins d'un jour
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 3600000)}{" "}
          {t("orders.datatable_templating_demo.hours")}
        </span>
      );
    } else if (diff < 604800000) {
      // Moins d'une semaine
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 86400000)}{" "}
          {t("orders.datatable_templating_demo.days")}
        </span>
      );
    } else if (diff < 604800000 + 86400000) {
      // Environ une semaine
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {t("orders.datatable_templating_demo.a_week")}
        </span>
      );
    } else {
      return <span>{date.format("YYYY-MM-DD, H:mm:ss")}</span>;
    }
  };
  const changeShip = async (data, status) => {
    try {
      return await runChangeShip({
        data,
        status,
        store,
        products: productss,
        setErrorMessage,
        t,
        noestSelectedDeskCode,
        yalidineSelectedDeskCode,
        setNoestPendingData,
        setNoestPendingResolve,
        setNoestPendingReject,
        setNoestModalOpen,
        setYalidinePendingData,
        setYalidinePendingResolve,
        setYalidinePendingReject,
        setYalidineModalOpen,
        onSuccess: (updatedOrder) => {
          try {
            onSave(updatedOrder);
          } catch (e) {
            console.error("onSuccess callback error:", e);
          }
        },
      });
    } catch (error) {
      const message = getUploadLivraisonErrorMessage(error);
      if (message) setErrorMessage(message);
      console.error("Error in changeShip:", error);
      throw error;
    }
  };

  //cette fonction crée une interface permettant à l'utilisateur de sélectionner une société de livraison
  const shipActionTemplate = (rowData) => {
    const handleUpload = () => {
      // تنفيذ الرفع لشركة التوصيل هنا
    };

    const menu = (
      <Menu className="right-to-left">
        {!shouldShowLockedContent(rowData) && (
          <>
            {!!store.Maystro && (
              <Menu.Item
                key="1"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(1)}>Maystro</span>
              </Menu.Item>
            )}
            {!!store.Zrexpress && (
              <Menu.Item
                key="2"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(2)}>{t("zr_express")}</span>
              </Menu.Item>
            )}
            {!!store.Ecotrack && !!store.Uecotrack && (
              <Menu.Item
                key="3"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(3)}>{t("services.foorCall.companies.ecotrack")}</span>
              </Menu.Item>
            )}
            {!!store.Userguid && !!store.ApitokenNord && (
              <Menu.Item
                key="4"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(4)}>Nord Et Ouest</span>
              </Menu.Item>
            )}
            {!!store.Yalidineid && !!store.Yalidinetoken && (
              <Menu.Item
                key="5"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(4)}>{t("services.foorCall.companies.yalidine")}</span>
              </Menu.Item>
            )}
            {!!store.UserguidGuepex && !!store.Apitokenguepex && (
              <Menu.Item
                key="6"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(6)}>{t("services.foorCall.companies.guepex")}</span>
              </Menu.Item>
            )}
            {!!store.apielogistia && (
              <Menu.Item
                key="7"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(7)}>elogistia</span>
              </Menu.Item>
            )}
            {!!store.ZimouToken && (
              <Menu.Item
                key="8"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(8)}>Zimou Express</span>
              </Menu.Item>
            )}
            {!!store.mdm_apikey && (
              <Menu.Item
                key="10"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(10)}>MDM Express</span>
              </Menu.Item>
            )}
            {!!store.AmeexKey && !!store.AmeexId && (
              <Menu.Item
                key="9"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(9)}>Ameex</span>
              </Menu.Item>
            )}
            {!!store.YalitecId && !!store.YalitecToken && (
              <Menu.Item
                key="11"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(11)}>Yalitec</span>
              </Menu.Item>
            )}
            {!!store.coliv_token && !!store.coliv_pubKey && (
              <Menu.Item
                key="11"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(11)}>Colivraison</span>
              </Menu.Item>
            )}
          </>
        )}
      </Menu>
    );

    return (
      <Dropdown overlay={menu}>
        <Button
          type="primary"
          size="small"
          className="hp-bg-black-100 hp-border-color-black-100 hp-hover-bg-black-80 hp-hover-border-color-black-80"
        >
          {t("ui.actions")}
        </Button>
      </Dropdown>
    );
  };

  // Génère un lien vers les détails de la commande avec ses informations et le produit associé.
  const orderNumber = (rowData) => {
    // Si c'est un confirmateur et la commande n'est pas assignée à lui, ne rien afficher
    if (
      isConfirmer &&
      hasMultipleConfirmers &&
      rowData?.assignedConfirmerId &&
      rowData?.assignedConfirmerId !== currentWorkerId
    ) {
      return <></>;
    }

    // Si c'est un confirmateur et pas assignée du tout, ne rien afficher
    if (isConfirmer && hasMultipleConfirmers && !rowData?.assignedConfirmerId) {
      return <></>;
    }

    return (
      <button
        type="button"
        onClick={(event) => handleOpenOrder(rowData, event)}
        className="bg-transparent border-0 p-0 text-start"
      >
        <span className="text-[#9b59bf] hover:underline">{rowData.index}</span>
      </button>
    );
  };
  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  // retourne le total de la commande
  const orderTotal = (rowData) => {
    return (
      <>
        <span className="bg-[#faf1ff] dark:bg-[#3c3a3d] text-[#9e68ba] dark:text-[#e4b8e4] px-3 py-1 rounded-lg">
          {rowData.total} {currencyMap[store.currencySymbol]?.[i18n.language]}
        </span>
      </>
    );
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;
  // lien vers le nom
  const customerName = (rowData) => {
    return (
      <button
        type="button"
        onClick={(event) => handleOpenOrder(rowData, event)}
        className="bg-transparent border-0 p-0 text-start"
      >
        <span className="text-[#9b59bf] hover:underline">{rowData.name}</span>
      </button>
    );
  };
  // 6-1 6-2 6-3
  const statusOptions = {
    1: "جديد",
    3: "مؤكدة",
    9: "مؤكدة من قبل العميل",
    "11-2": "لم يرد على الاتصال",
    "11-3": "مؤجلة",
    6: "ملغي",
    "11-5": "ملغى من قبل العميل",
    "11-1": "انتظار اتصال العميل",
    "11-4": "الخط مغلق",
    4: "رفع لشركة التوصيل",
    5: "مكتملة",
  };

  // دالة لتقليل النص وإضافة النقاط الثلاث إذا كان أطول من الحد الأقصى
  const maxChars = 25;
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }
    return text;
  };

  // Met à jour le statut d'une commande, enregistre l'historique des statuts et envoie une notification Telegram au client.
  const changeStatus = async (data, status) => {
    // Vérifier les permissions pour les confirmateurs
    if (isConfirmer && hasMultipleConfirmers) {
      if (!data?.assignedConfirmerId) {
        Swal.fire({
          icon: "warning",
          title:
            t("orders.datatable_templating_demo.warning") || t("Products.modalAdd.submitduplicateAlert"),
          text:
            t("orders.datatable_templating_demo.must_assign_first") ||
            t("insightads.datatable_templating_demo.must_assign_first"),
          confirmButtonText: t("orderDetails.alerts.ok") || t("ship.ok"),
        });
        return;
      }

      if (data.assignedConfirmerId !== currentWorkerId) {
        Swal.fire({
          icon: "error",
          title: t("orders.error") || t("error"),
          text:
            t("orders.datatable_templating_demo.not_assigned_to_you") ||
            t("insightads.datatable_templating_demo.not_assigned_to_you"),
          confirmButtonText: t("orderDetails.alerts.ok") || t("ship.ok"),
        });
        return;
      }
    }

    const currentTime = new Date();
    const updatedStatusTimeline = [
      ...(data.statusTimeline || []),
      { status, timestamp: currentTime, ownby: account.name },
    ];
    const telegramBotToken = "6672968395:AAHFokejZq4r6GRRDHlm2FDqXk0-pXoQmOs";
    const chatId = store.Idtelegram;
    const product = productdata.find(
      (product) => product.id === data.productId,
    );
    const truncatedProductName = truncateText(
      data.nameproduct ? data.nameproduct : product.name,
      maxChars,
    );
    const statusMessages = {};

    if (store.done === true) {
      statusMessages["5"] =
        `✅ تم إتمام الطلب بنجاح! ✅\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنود إبلاغكم بأنه تم إتمام الطلب بنجاح. يمكنكم متابعة تفاصيل وضعية الطلب وموعد التسليم عبر البوابة الخاصة بكم. شكرًا لتفهمكم وثقتكم في خدماتنا.`;
    }
    const statusMessagess = {};

    if (store.termine === true) {
      statusMessagess["11-2"] =
        `📢 طلب لم يرد على الاتصال! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "لم يرد على الاتصال". نقترح محاولة الاتصال مع العميل لاحقًا لتأكيد التفاصيل. شكرًا لك على تفانيك في تقديم خدمة عالية الجودة.`;
      statusMessagess["11-3"] =
        `📢 طلب مؤجل! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تأجيل تسليم الطلب إلى وقت لاحق. ننصح بجدولة الاتصال بالعميل لترتيب تفاصيل موعد التسليم المناسب. نقدر جهودك في تقديم الخدمة المميزة.`;
      statusMessagess["11-5"] =
        `📢 إلغاء طلب! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم إلغاء الطلب من قبل العميل. يُرجى ترتيب إجراءات الإلغاء ومتابعة الإجراءات المناسبة. نشكرك على تفهمك واهتمامك برضاء العملاء.`;
      statusMessagess["11-1"] =
        `📢 انتضار اتصال العميل ! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "انتظار اتصال العميل". يُرجى محاولة التواصل مع العميل بأسرع وقت ممكن لتأكيد التفاصيل وترتيب التسليم المناسب. شكرًا لك على اهتمامك بتقديم الخدمة الفائقة.`;
      statusMessagess["11-4"] =
        `📢 طلب خط مغلق! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "الخط مغلق". نود إبلاغك بأن العميل قد يكون غير متاح حاليًا. ننصح بمحاولة الاتصال في وقت لاحق أو ترتيب وقت مناسب للتواصل. نشكرك على جهودك في تقديم أفضل خدمة للعملاء.`;
    }

    const statusMessagees = {};

    if (store.confrim === true) {
      statusMessagees["3"] =
        `📢 طلب مؤكد! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "مؤكدة". ننصح برفع الطلب في شركة التوصيل لبدء إجراءات التوصيل. شكرًا لك على جهودك في تقديم أفضل تجربة للعميل وتسهيل عملية التسليم.`;
    }
    if (store.confrim === true) {
      statusMessagees["9"] =
        `📢 طلب مؤكد من قبل العميل! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "مؤكدة". ننصح برفع الطلب في شركة التوصيل لبدء إجراءات التوصيل. شكرًا لك على جهودك في تقديم أفضل تجربة للعميل وتسهيل عملية التسليم.`;
    }
    const statusMessageesNew = {};

    if (store.new === true) {
      statusMessageesNew["1"] =
        `📢 تحديث حالة الطلب! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nلدينا تحديث جديد على حالة الطلب. يُرجى تأكيد ومتابعة الحالة الجديدة في أقرب وقت ممكن. شكرًا لك على اهتمامك بتقديم خدمة مميزة وتلبية احتياجات العملاء بكل دقة وسرعة.`;
    }

    const statusMessagessDD = {};

    if (store.delevery === true) {
      statusMessagessDD["4"] =
        `🚚 طلب تم رفعه لشركة التوصيل! 🚚\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنود إعلامك بأنه تم رفع الطلب لشركة التوصيل بنجاح. يتم الآن التنسيق لبدء عملية التسليم. نشكرك على جهودك واهتمامك بتقديم تجربة مميزة للعميل.`;
    }
    const statusMessagessCC = {};

    if (store.cancel === true) {
      statusMessagessDD["6"] =
        `❌ تم الغاء الطلب! ❌\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنأسف لإبلاغكم بأن العميل قام بإلغاء الطلب. تم تحديث حالة الطلب بنجاح. شكرًا على جهودك في تقديم الخدمة ونأمل في تقديم تجربة أفضل في المستقبل.`;
    }
    const message =
      statusMessages[status] ||
      statusMessagees[status] ||
      statusMessagessCC[status] ||
      statusMessageesNew[status] ||
      statusMessagessDD[status] ||
      statusMessagess[status];
    const messageC = `📵 حالة الطلب غير مكتملة! 📵\n\n👤 العميل: ${data.name}\n📞 الهاتف: ********\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنرجو إعلامك بأن رقم هاتف الطلب غير ظاهر بسبب عدم توفر رصيد كافي أو عدم تفعيل باقتك في فوورويب . يُرجى التحقق من حالة رصيدك وتفعيل الباقة لتتمكن من متابعة تفاصيل طلبك بشكل كامل. شكرًا على تفهمك ونتطلع لخدمتك بشكل أفضل.`;
    const updatedData = {
      ...data,
      deleveryStatus: status,
      statusTimeline: updatedStatusTimeline,
      ownby: account.name,
    };
    await workerAPI.updateOrder(data.id, updatedData);
    onSave(updatedData);

    {
      shouldShowLockedContent(data)
        ? axios
          .post(
            `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
            {
              chat_id: chatId,
              text: messageC,
            },
          )
          .then((response) => {
            console.log("تم إرسال الإشعار بنجاح");
          })
          .catch((error) => {
            console.error("حدث خطأ أثناء إرسال الإشعار", error);
          })
        : axios
          .post(
            `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
            {
              chat_id: chatId,
              text: message,
            },
          )
          .then((response) => {
            console.log("تم إرسال الإشعار بنجاح");
          })
          .catch((error) => {
            console.error("حدث خطأ أثناء إرسال الإشعار", error);
          });
    }
  };

  //update paid
  const changepaid = async (data, status) => {
    const updatedData = { ...data, paid: status };
    await workerAPI.updateOrder(data.id, updatedData);
  };

  /** Fonction pour générer le contenu de la ligne étendue dans un tableau de commandes.

  Cette fonction affiche les détails des produits d'une commande avec la possibilité
  d'effectuer plusieurs actions, notamment :

  - Ajouter ou supprimer une adresse IP à la liste des adresses bloquées.
  - Supprimer un produit spécifique d'une commande.
  - Afficher les détails des produits avec des options dynamiques (couleur, taille, etc.).
  - Gérer l'affichage des sous-menus des produits.*/
  const rowExpansionTemplate = (data) => {
    const addIpToAdressipblock = async (data) => {
      Swal.fire({
        title: t("ship.confirm_block"),
        text: t("orderDetails.alerts.block.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#e87778",
        confirmButtonText: t("ship.confirm_block_button"),
        cancelButtonText: t("annule"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storeDocRef = doc(db, "store", store.id);

          if (data.ipAddress) {
            try {
              if (!store.Adressipblock?.includes(data.ipAddress)) {
                const result = await workerAPI.updateStore({
                  Adressipblock: [
                    ...(store.Adressipblock || []),
                    data.ipAddress,
                  ],
                });
                dispatch(fetchStore(result.store));
                apicache(account, products);
              }
              Swal.fire(t("ship.block_success"), ". تم حظر عنوان الايبي بنجاح", "success");
            } catch (error) {
              console.error("Error adding الايبي: ", error);
              Swal.fire(t("ship.error"), ". حدث خطأ أثناء حظر عنوان الايبي", "error");
            }
          } else {
            console.error("No الايبي address found in data");
            Swal.fire(t("ship.error"), ". لا يوجد عنوان الايبي في الطلب", "error");
          }
        }
      });
    };
    const toggleSubmenu = (productId) => {
      setShowSubmenus((prevShowSubmenus) => ({
        ...prevShowSubmenus,
        [productId]: !prevShowSubmenus[productId],
      }));
    };
    const onDelete = async (product) => {
      try {
        if (data.products && Array.isArray(data.products)) {
          const updatedProducts = data.products.filter(
            (p) => p.name !== product.name || p.id !== product.id,
          );

          if (updatedProducts.length === data.products.length) {
            console.warn("Produit non trouvé dans la commande");
            Swal.fire({
              icon: "warning",
              title: t("warning"),
              text: t("orders.product_not_found"),
            });
            return;
          }

          const removedProductTotal = product.price * product.quantity;
          const newTotal = (data.total || 0) - removedProductTotal;

          await workerAPI.updateOrder(data.id, {
            products: updatedProducts,
            total: newTotal >= 0 ? newTotal : 0,
          });

          // setData({
          //   ...data,
          //   products: updatedProducts,
          //   total: newTotal >= 0 ? newTotal : 0
          // });

          Swal.fire({
            icon: "success",
            title: t("success"),
            text: t("orders.product_deleted_success"),
            timer: 2000,
            timerProgressBar: true,
          });
        } else {
          console.error("Aucun produit trouvé dans la commande");
          Swal.fire({
            icon: "error",
            title: t("error"),
            text: t("orders.no_products_found"),
          });
        }
      } catch (error) {
        console.error("Erreur lors de la suppression du produit:", error);
        Swal.fire({
          icon: "error",
          title: t("error"),
          text:
            error.response?.data?.message ||
            error.message ||
            t("orders.delete_product_error"),
        });
      }
    };
    const removeIpFromAdressipblock = async (data) => {
      Swal.fire({
        title: t("ship.confirm_delete"),
        text: t("orderDetails.alerts.unblock.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#e87778",
        confirmButtonText: t("orderDetails.alerts.unblock.confirm"),
        cancelButtonText: t("annule"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storeDocRef = doc(db, "store", store.id);

          if (data.ipAddress) {
            try {
              if (store.Adressipblock?.includes(data.ipAddress)) {
                const result = await workerAPI.updateStore({
                  Adressipblock: [
                    ...store.Adressipblock.filter(
                      (ip) => ip !== data.ipAddress,
                    ),
                  ],
                });
                dispatch(fetchStore(result.store));
                apicache(account, products);
              }
              Swal.fire(t("ship.delete_success"), ". تم حذف عنوان الايبي بنجاح", "success");
            } catch (error) {
              console.error("Error removing الايبي: ", error);
              Swal.fire(t("ship.error"), ". حدث خطأ أثناء حذف عنوان الايبي", "error");
            }
          } else {
            console.error("No الايبي address found in data");
            Swal.fire(t("ship.error"), ". لا يوجد عنوان الايبي في الطلب", "error");
          }
        }
      });
    };
    const timestamp = data.timeStamp;
    const date = new Date(timestamp._seconds * 1000); // تحويل ثواني الوقت إلى مللي ثواني وإنشاء كائن التاريخ
    const formattedDate = date.toLocaleString();
    console.log(timestamp._seconds);
    const product = productdata.find(
      (product) => product.id === data.productId,
    );
    let productsToShow = [];
    if (data.products && data.products.length > 0) {
      productsToShow = data.products.map((p) =>
        productdata.find((product) => product.id === p.id),
      );
    }
    return (
      <div className="orders-subtable row">
        <div className="max-w-2xl mx-auto py-0 md:px-8">
          {data.nameproduct ? (
            <>
              {data.products ? (
                <ul>
                  {data.products.map((product) => (
                    <div
                      className="max-w-2xl mx-auto py-0 md:px-2 relative"
                      key={product.name}
                    >
                      <div
                        className="d-flex justify-content-between w-100 p-1-2 border4 card"
                        onClick={() => toggleSubmenu(product.name)}
                      >
                        <li className="flex gap-4 items-center">
                          <img
                            src={
                              product.image
                                ? product.image
                                : "/product-foorweb.png"
                            }
                            className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                          />
                          <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                            {product.name}
                          </div>
                          <span className="text-sm">
                            {product.price} {localizedCurrency}
                          </span>
                          <i
                            className={`bi ${showSubmenus[product.name]
                                ? "bi-chevron-double-up"
                                : "bi-chevron-double-down"
                              }`}
                            style={{ color: "#45a788" }}
                          ></i>
                        </li>
                      </div>

                      <div
                        className={`submenu ${showSubmenus[product.name] ? "" : "open"
                          }`}
                      >
                        <div className="w-100 p-1-2 border4 ">
                          {product?.options?.offer && (
                            <div className="d-flex justify-content-between w-100 p-1-2-3">
                              <p className="m-0">{t("offer")} :</p>
                              <p className="m-0 text-success">
                                <b>{product?.options?.offer}</b>
                              </p>
                            </div>
                          )}
                          {product?.options?.offer && (
                            <hr className="m-0 p-0" />
                          )}
                          <div className="d-flex justify-content-between w-100 p-1-2-3">
                            <p className="m-0"> {t("color")} :</p>
                            <p className="m-0 text-success">
                              <b>
                                <b>
                                  <b>
                                    {typeof product?.options?.color ===
                                      "object" &&
                                      !Array.isArray(product?.options?.color)
                                      ? Object.entries(product?.options?.color)
                                        .length > 0
                                        ? Object.entries(
                                          product?.options?.color,
                                        ).map(([key, value]) => (
                                          <span key={key}>
                                            {key}:{" "}
                                            {Array.isArray(value)
                                              ? value.join(", ")
                                              : value}
                                            <br />
                                          </span>
                                        ))
                                        : t("unspecified")
                                      : typeof product?.options?.color ===
                                        "string"
                                        ? product?.options?.color.trim() === ""
                                          ? t("unspecified")
                                          : product?.options?.color
                                        : t("unspecified")}
                                  </b>
                                </b>
                              </b>
                            </p>
                          </div>
                          <hr className="m-0 p-0" />
                          <div className="d-flex justify-content-between w-100 p-1-2-3">
                            <p className="m-0">{t("size")} :</p>
                            <p className="m-0 text-success">
                              <b>
                                {typeof product?.options?.size === "object" &&
                                  !Array.isArray(product?.options?.color)
                                  ? Object.entries(product?.options?.size)
                                    .length > 0
                                    ? Object.entries(
                                      product?.options?.size,
                                    ).map(([key, value]) => (
                                      <span key={key}>
                                        {key}:{" "}
                                        {Array.isArray(value)
                                          ? value.join(", ")
                                          : value}
                                        <br />
                                      </span>
                                    ))
                                    : t("unspecified")
                                  : typeof product?.options?.size === "string"
                                    ? product?.options?.size.trim() === ""
                                      ? t("unspecified")
                                      : product?.options?.size
                                    : t("unspecified")}
                              </b>
                            </p>
                          </div>
                          <hr className="m-0 p-0" />
                          <div className="d-flex justify-content-between w-100 p-1-2-3">
                            <p className="m-0">{t("quantity")}:</p>
                            <p className="m-0 text-success">
                              <b>{product.quantity}</b>
                            </p>
                          </div>
                        </div>
                      </div>

                      <span
                        className="absolute top-0 left-0 p-1 "
                        style={{
                          backgroundColor: "rgba(69, 167, 77, 0)",
                          marginTop: "-11px",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <i
                          onClick={(e) => {
                            data.products.length !== 1
                              ? onDelete(product)
                              : handleDelete(data);
                          }}
                          className="bi bi-x-circle"
                          style={{ color: "red", fontSize: "18px" }}
                        ></i>
                      </span>
                    </div>
                  ))}
                </ul>
              ) : (
                <ul>
                  <div className="max-w-2xl mx-auto py-0 md:px-8">
                    <div className="d-flex justify-content-between w-100 p-1-2 border4">
                      <li className="flex gap-4 items-center">
                        <img
                          src={data.image ? data.image : "/product-foorweb.png"}
                          className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                        />
                        <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                          {data.nameproduct}
                        </div>
                        <span className="text-sm">
                          {data.total - data.deliveryPrice} {localizedCurrency}
                        </span>
                      </li>
                    </div>
                  </div>
                </ul>
              )}
            </>
          ) : data.products ? (
            <ul>
              {data?.nameproduct
                ? productsToShow.map((product) => (
                  <div
                    className="max-w-2xl mx-auto py-0 md:px-8"
                    key={product?.id}
                  >
                    <div className="d-flex justify-content-between w-100 p-1-2 border4">
                      <li className="flex gap-4 items-center">
                        <img
                          src={
                            product?.image
                              ? product?.image
                              : "/product-foorweb.png"
                          }
                          className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                        />
                        <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                          {product?.name}
                        </div>
                        <span className="text-sm">
                          {product?.price} {localizedCurrency}
                        </span>
                      </li>
                    </div>
                  </div>
                ))
                : data.products.map((product, index) => (
                  <div className="max-w-2xl mx-auto py-0 md:px-8">
                    <div className="d-flex justify-content-between w-100 p-1-2 border4">
                      <li className="flex gap-4 items-center">
                        <img
                          src={
                            product.image
                              ? product.image
                              : "/product-foorweb.png"
                          }
                          className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                        />
                        <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                          {product.name}
                        </div>
                        <span className="text-sm">
                          {data.total - data.deliveryPrice}{" "}
                          {localizedCurrency}
                        </span>
                      </li>
                    </div>
                  </div>
                ))}
            </ul>
          ) : (
            <ul>
              <div className="d-flex justify-content-between w-100 p-1-2 border4">
                <li className="flex gap-4 items-center">
                  <img
                    src={product ? product.image : "/product-foorweb.png"}
                    className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                  />
                  <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                    {product ? product.name : ""}
                  </div>
                  <span className="text-sm">
                    {data.total} {localizedCurrency}
                  </span>
                </li>
              </div>
            </ul>
          )}
        </div>

        <div className="mt-2 dark:text-gray-300">
          <p className="text-gray-600 text-sm font-semibold sm:text-xs dark:text-gray-300">
            {t("orders.datatable_templating_demo.order_status_updates")}:
          </p>
          <div
            className="flex items-center"
            style={{ overflowX: "auto", whiteSpace: "nowrap" }}
          >
            {data.statusTimeline ? (
              data.statusTimeline.map((statusUpdate, idx, array) => {
                const isFirstItem = idx === 0;
                return (
                  <div
                    key={idx}
                    className={`flex items-center dark:text-gray-300 ${!isFirstItem ? "ml-2" : ""
                      }`}
                  >
                    {!isFirstItem && (
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/3575/3575967.png"
                        alt=""
                        className="w-4 h-4"
                        style={{ marginLeft: "5px", marginRight: "5px" }}
                      />
                    )}
                    <img
                      src={
                        statusUpdate.status === "1"
                          ? "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                          : statusUpdate.status === "2"
                            ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                            : statusUpdate.status === "9"
                              ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                              : statusUpdate.status === "3"
                                ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                : statusUpdate.status === "4"
                                  ? "https://cdn-icons-png.flaticon.com/128/1559/1559859.png"
                                  : statusUpdate.status === "5"
                                    ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                    : statusUpdate.status === "6"
                                      ? "https://cdn-icons-png.flaticon.com/128/391/391247.png"
                                      : statusUpdate.status === "11-1"
                                        ? "https://cdn-icons-png.flaticon.com/128/2593/2593514.png"
                                        : statusUpdate.status === "11-2"
                                          ? "https://cdn-icons-png.flaticon.com/128/9946/9946401.png"
                                          : statusUpdate.status === "11-3"
                                            ? "../agenda.png"
                                            : statusUpdate.status === "11-4"
                                              ? "https://cdn-icons-png.flaticon.com/128/8402/8402548.png"
                                              : statusUpdate.status === "11-5"
                                                ? "https://cdn-icons-png.flaticon.com/128/7787/7787073.png"
                                                : "https://cdn-icons-png.flaticon.com/128/11442/11442042.png"
                      }
                      className="w-10 h-10"
                      alt=""
                    />
                  </div>
                );
              })
            ) : (
              <p className="text-gray-700 text-center dark:text-gray-400 mx-auto">
                {t("orders.datatable_templating_demo.no_Update")}
              </p>
            )}
          </div>
        </div>
        <div>
          <h4 className=" font-semibold sm:text-lg dark:text-gray-300">
            {t("orders.datatable_templating_demo.receive_order")}
          </h4>
          <p className="text-[#9e68ba]">{formattedDate}</p>
        </div>
        <div className="mt-2 grid gap-8 sm:grid-cols-2 lg:grid-cols-2">
          <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d]">
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.full_name")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>{data.name}</b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.phone_number")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {" "}
                  {!canViewPhoneForRow(data) ? (
                    <span className="text-muted">{t("actions.unlock")}</span>
                  ) : shouldShowLockedContent(data) ? (
                    <i className="fs-3" onClick={() => handlePay(data)}>
                      <img src={"/lock.png"} className="mx-auto" />
                    </i>
                  ) : (
                    <a
                      href={`tel:${data.phone}}`}
                      style={{ textDecoration: "none" }}
                    >
                      {data.phone}
                    </a>
                  )}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.full_address")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.state}.{data.commune}.{data.address}{" "}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.customer_note")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {data?.note?.trim() !== "" || data?.options?.trim() !== ""
                    ? data?.note?.trim() || data?.options?.trim()
                    : t("orders.datatable_templating_demo.no_note")}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.ip_address")} :
              </p>
              <p className="m-0 text-success">
                <b>{data.ipAddress ? data.ipAddress : "-"}</b>
              </p>
            </div>
          </div>

          <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d]">
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.product_value")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.total -
                    (data.deleveryPrice
                      ? data.deleveryPrice
                      : data.deliveryPrice)}{" "}
                  {localizedCurrency}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.quantity")} :
              </p>
              <p className="m-0 text-success">
                <b> {data.qty} </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.delivery_fees")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.deleveryPrice ? data.deleveryPrice : data.deliveryPrice}{" "}
                  {localizedCurrency}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.grand_total")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.total} {localizedCurrency}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => addIpToAdressipblock(data)}
              >
                {t("orders.datatable_templating_demo.block")}
              </button>
              <button
                type="button"
                className="btn btn-outline-warning"
                onClick={() => removeIpFromAdressipblock(data)}
              >
                {t("orders.datatable_templating_demo.delete")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleDelete = async (data) => {
    Swal.fire({
      title: t("ship.confirm_delete"),
      html: `
        <p>هل أنت متأكد من القيام بذلك؟</p>
        <small style="display:block;margin-top:10px;color:gray;">
          تحذير : إذا أنت في حالة المحذوفة  سيتم حذف الطلب نهائيا.
        </small>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: t("ship.yes"),
      cancelButtonText: t("ship.no"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const audio = new Audio("/Mouth woosh_42.wav");
        audio.play();
        if (data.deleveryStatus === "8") {
          await workerAPI.deleteOrder(data.id, {
            deleted: 1,
            deleveryStatus: data.deleveryStatus,
          });
          onSave({ ...data, deleted: 1, deleveryStatus: data.deleveryStatus });
        } else {
          await workerAPI.deleteOrder(data.id, {
            deleveryStatus: "8",
          });
          onSave({ ...data, deleveryStatus: "8" });
        }
      }
    });
  };

  const navigate = useNavigate();

  const navigateToOrder = (rowData) => {
    if (rowData && rowData.id) {
      navigate(`/team/orderProfile/${rowData.id}`, {
        state: {
          orderData: rowData,
          productData: productdata.find(
            (product) => product.id === rowData.productId,
          ),
        },
      });
    } else {
      console.error("Order ID not found!");
    }
  };

  const handleUpdate = async (rowData) => {
    setData(rowData);
    setLgShow(true);
  };

  const actionTemplate = (rowData) => {
    debugLog("actionTemplate(render)", {
      rowId: rowData?.id,
      isValid: rowData?.isValid,
      typeofIsValid: typeof rowData?.isValid,
      deleveryStatus: rowData?.deleveryStatus,
    });

    return (
      <Dropdown
        overlay={
          <Menu className="">
            <Menu.Item
              key="1"
              className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi "
              size={16}
              onClick={
                !!account.store
                  ? () => handleUpdate(rowData)
                  : () => {
                    message();
                  }
              }
            >
              <i
                style={{
                  display: "flex",
                  textAlign: "center",
                  paddingRight: "2px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-file-pen-line hover:text-green-500 ml-2"
                >
                  <path d="m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2" />
                  <path d="M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" />
                  <path d="M8 18h1" />
                </svg>
                {t("orders.datatable_templating_demo.edit")}
              </i>
            </Menu.Item>
            <Menu.Item
              key={rowData.id}
              className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss  hover:text-green-500"
              size={16}
              onClick={() => handleOpenOrder(rowData)} // Pass the entire rowData
            >
              <i
                style={{
                  display: "flex",
                  textAlign: "center",
                  paddingRight: "2px",
                  alignItems: "center",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-eye ml-2 hover:text-green-500"
                >
                  <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                {t("orders.datatable_templating_demo.preview")}
              </i>
            </Menu.Item>
            {canDeleteOrders && (
              <Menu.Item
                key="3"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 "
                size={16}
                onClick={
                  !!account.store
                    ? () => {
                      handleDelete(rowData);
                    }
                    : () => {
                      message();
                    }
                }
              >
                <i
                  style={{
                    color: "#f21919",
                    display: "flex",
                    textAlign: "center",
                    paddingRight: "2px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#f21919"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="lucide lucide-trash2-icon lucide-trash-2 ml-2"
                  >
                    <path d="M3 6h18" />
                    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                    <line x1="10" x2="10" y1="11" y2="17" />
                    <line x1="14" x2="14" y1="11" y2="17" />
                  </svg>
                  {t("orders.datatable_templating_demo.delete")}
                </i>
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <button className="bot1 dark:bg-[#181919] dark:!text-gray-300 p-2">
          <Edit className="w-5 h-5" />
        </button>
      </Dropdown>
    );
  };
  const groubeUpdates = async (data) => {
    const batch = writeBatch(db);
    const telegramBotToken = "6672968395:AAHFokejZq4r6GRRDHlm2FDqXk0-pXoQmOs";
    const chatId = store.Idtelegram;
    const allMessage = `📢 تم تغيير حالات طلباتك بشكل جماعي. تفقد متجرك للاطلاع على المستجدات وتحديثات الطلبات. 🛍️💼`;
    setIsMultiple(true);
    if (deleveryCompany !== "") {
      const normalOrders = selectedProducts.filter(
        (order) => !order.stopdeskDelivery,
      );
      const stopdeskOrders = selectedProducts.filter(
        (order) => order.stopdeskDelivery,
      );

      try {
        if (normalOrders.length > 0) {
          const normalPromises = normalOrders.map((order) =>
            changeShip(order, deleveryCompany).catch((error) => ({
              order,
              error: error.message,
            })),
          );

          const normalResults = await Promise.allSettled(normalPromises);

          normalResults.forEach((result, index) => {
            if (result.status === "rejected" || result.value?.error) {
              console.error(
                `Erreur commande normale ${normalOrders[index].id}:`,
                result.reason || result.value.error,
              );
            }
          });
        }

        if (stopdeskOrders.length > 0) {
          await processStoredeskOrders(stopdeskOrders);
        }

        if (normalOrders.length > 0 || stopdeskOrders.length > 0) {
          axios
            .post(
              `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
              {
                chat_id: chatId,
                text: allMessage,
              },
            )
            .catch((error) =>
              console.error("Erreur notification Telegram:", error),
            );
        }
      } catch (error) {
        console.error("Erreur lors du traitement des commandes:", error);
        Swal.fire({
          title: t("ui.processingError"),
          text: t("ui.ordersProcessingError"),
          icon: "error",
        });
      }
    }

    // Traitement des mises à jour de statut en lot
    if (bluck !== "") {
      if (bluck === "7") {
        selectedProducts.forEach((order) => {
          const sfRef = doc(db, "orders", order.id);
          batch.set(sfRef, { ...order, deleted: 1 });
        });
      } else {
        selectedProducts.forEach((order) => {
          const sfRef = doc(db, "orders", order.id);
          batch.update(sfRef, { deleveryStatus: bluck });
        });
      }

      try {
        await batch.commit();

        axios
          .post(`https://api.telegram.org/bot${telegramBotToken}/sendMessage`, {
            chat_id: chatId,
            text: allMessage,
          })
          .catch((error) =>
            console.error("Erreur notification Telegram:", error),
          );

        if (bluck === "7") {
          Swal.fire({
            title: t("ui.deletedSuccessfully"),
            icon: "success",
            confirmButtonText: t("ship.yes"),
            confirmButtonColor: "rgb(141, 93, 167)",
          });
        }
      } catch (error) {
        Swal.fire({
          title: t("foorAi.history.error.generic"),
          text: t("FormSettings.alerts.save_error.text"),
          icon: "error",
        });
      }
    }
  };

  const processStoredeskOrders = async (stopdeskOrders) => {
    return new Promise((resolve) => {
      let currentIndex = 0;
      const results = [];

      const processNext = async () => {
        if (currentIndex >= stopdeskOrders.length) {
          resolve(results);
          return;
        }

        const currentOrder = stopdeskOrders[currentIndex];

        try {
          const result = await changeShip(currentOrder, deleveryCompany);
          results.push({ order: currentOrder, success: true, result });
        } catch (error) {
          results.push({
            order: currentOrder,
            success: false,
            error: error.message,
          });
          console.error(
            `Erreur commande stopdesk ${currentOrder.id}:`,
            error.message,
          );
        }

        currentIndex++;

        setTimeout(processNext, 500);
      };

      processNext();
    });
  };

  const selectTemplate = (rowData) => {
    return (
      <div>
            <Form.Check
          type={"checkbox"}
          checked={selectedProducts.map((p) => p.id).includes(rowData.id)}
          onChange={() => {
            const alreadySelected = selectedProducts
              .map((p) => p.id)
              .includes(rowData.id);

            const next = !alreadySelected
              ? [...selectedProducts, rowData]
              : selectedProducts.filter((p) => p.id !== rowData.id);

            debugLog("row checkbox onChange", {
              toggledRowId: rowData?.id,
              toggledRow: rowData
                ? {
                    isValid: rowData.isValid,
                    typeofIsValid: typeof rowData.isValid,
                    deleveryStatus: rowData.deleveryStatus,
                  }
                : null,
              nextCount: next?.length,
              nextFirst: next?.[0]
                ? {
                    id: next[0].id,
                    isValid: next[0].isValid,
                    typeofIsValid: typeof next[0].isValid,
                    deleveryStatus: next[0].deleveryStatus,
                  }
                : null,
              lockedIds: next
                ?.filter((o) => shouldShowLockedContent(o))
                ?.map((o) => o?.id),
            });

            setSelectedProducts(next);
          }}
        />
      </div>
    );
  };
  const [fallbackProducts, setFallbackProducts] = useState([]);

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const htmlToPdfBytes = async (element) => {
    return new Promise((resolve) => {
      const opt = {
        margin: 0,
        filename: "fallback.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      };

      html2pdf()
        .set(opt)
        .from(element)
        .outputPdf("arraybuffer")
        .then((pdfBytes) => {
          resolve(pdfBytes);
        });
    });
  };

  const handleDownloadAndPrintLabels = async () => {
    const mergedPdf = await PDFDocument.create();
    const apiPrintedTrackings = new Set();

    for (const product of selectedProducts) {
      try {
        let response;

        switch (product.DC) {
          case "3":
            response = await fetch(
              `${store?.Uecotrack}/api/v1/get/order/label?tracking=${product.tracking}`,
              {
                method: "GET",
                headers: {
                  Authorization: `Bearer ${store?.Ecotrack}`,
                },
              },
            );
            break;

          case "1":
            const ord = JSON.stringify({
              orders_ids: [product.display_id_order || product.tracking],
            });

            response = await fetch(
              "https://backend.maystro-delivery.com/api/delivery/starter/starter_bordureau/",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Token ${store?.Maystro}`,
                },
                body: ord,
              },
            );
            break;

          default:
            const transformed = {
              data: [
                {
                  tracking: product.tracking || "",
                  weight: product.weight || "1.0",
                  stopdeskDelivery: product.stopdeskDelivery,
                  total: product.total,
                  name: product.name,
                  phone: shouldShowLockedContent(product)
                    ? "**********"
                    : product.phone,
                  state: product.state,
                  commune: product.commune,
                  address: product.address || "العنوان غير محدد",
                  qty: product.qty,
                  productId: product.products?.[0]?.id || product.id,
                  deliveryPrice: product.deliveryPrice,
                  nameproduct:
                    product.products?.[0]?.name || "المنتج غير معروف",
                },
              ],
              account: {
                name: account.name,
                phone: account.phone,
              },
              logo: store.logo,
              products:
                product.products?.map((p) => ({
                  id: p.id,
                  name: p.name,
                  size: p.options?.size || "",
                  color: p.options?.color || "",
                })) || [],
            };
            //droplet digital ocean not off
            response = await fetch(
              "https://backend.foorweb.online/api/createPdf",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(transformed, null, 2),
              },
            );
            break;
        }

        if (!response || !response.ok) {
          console.error(
            `Erreur HTTP ${response?.status} pour ${product.tracking}`,
          );
          continue;
        }

        const pdfBytes = await response.arrayBuffer();
        const singlePdf = await PDFDocument.load(pdfBytes);
        const copiedPages = await mergedPdf.copyPages(
          singlePdf,
          singlePdf.getPageIndices(),
        );
        copiedPages.forEach((page) => mergedPdf.addPage(page));

        apiPrintedTrackings.add(product.tracking);
      } catch (error) {
        console.error(`Erreur produit ${product.tracking} :`, error);
        continue;
      }
    }

    // 📦 Générer le PDF final fusionné
    const mergedPdfBytes = await mergedPdf.save();
    const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
    const blobURL = URL.createObjectURL(blob);

    // 🖨️ Impression via iframe
    const iframe = document.getElementById("pdfPrinter");
    if (iframe) {
      iframe.src = blobURL;
      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };
    } else {
      console.error("Iframe pdfPrinter introuvable dans le DOM.");
    }
  };

  const handleLabels = async () => {
    handleDownloadAndPrintLabels();
  };

  let isFunctionRunning = false;

  const handlePay = async (rowData) => {
    // إذا كانت الدالة تعمل بالفعل، فلا تقوم بتنفيذها مرة أخرى
    if (isFunctionRunning) {
      return;
    }

    isFunctionRunning = true; // تعيين المتغير إلى true للإشارة إلى أن الدالة تعمل حاليًا

    const isOnline = navigator.onLine;

    if (!isOnline) {
      // رسالة عندما لا يكون هناك اتصال بالإنترنت
      Swal.fire({
        icon: "error",
        title: t("ship.no_internet"),
        text: t("orderDetails.alerts.internet.text"),
        confirmButtonText: t("orders.datatable_templating_demo.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      isFunctionRunning = false; // استعادة المتغير إلى false بمجرد انتهاء الدالة
      return;
    }

    try {
      const nextAccount = await consumeSubscriptionToken({
        accountId: account?.id,
      });

      await updateDoc(doc(db, "orders", rowData?.id), {
        isValid: false,
      });

      dispatch(fetchAccount(nextAccount));
      isFunctionRunning = false;
    } catch (error) {
      if (error?.code === "INSUFFICIENT_TOKENS") {
        Swal.fire({
          icon: "error",
          title: t("ship.insufficient_balance"),
          text: t("ship.insufficient_balance_message"),
          confirmButtonText: t("ship.recharge_balance"),
          confirmButtonColor: "rgb(141, 93, 167)",
          showCancelButton: true,
          cancelButtonText: t("annule"),
          cancelButtonColor: "#e87778",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/plan";
          }
          isFunctionRunning = false;
        });
        return;
      }

      Swal.fire({
        icon: "error",
        title: t("orders.datatable_templating_demo.error"),
        text: t("ui.paymentProcessingError"),
        confirmButtonText: t("orders.datatable_templating_demo.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      isFunctionRunning = false;
    }
  };

  const canViewPhoneForRow = (rowData) =>
    !hasMultipleConfirmers ||
    !isConfirmer ||
    rowData?.assignedConfirmerId === currentWorkerId;

  const handleAssignToSelf = async (rowData) => {
    if (!currentWorkerId) {
      return false;
    }

    if (hasPendingAssignedOrder(rowData?.id)) {
      showPendingOrderAlert();
      return false;
    }

    const updatedData = {
      ...rowData,
      assignedConfirmerId: currentWorkerId,
      assignedConfirmerName: currentWorkerName || "Confirmer",
      assignedConfirmerAt: new Date(),
    };

    try {
      await workerAPI.updateOrder(rowData.id, updatedData);
      onSave(updatedData);
      return true;
    } catch (error) {
      console.error("Error assigning order to confirmer:", error);
      Swal.fire({
        icon: "error",
        title: t("orders.error") || t("error"),
        text:
          t("orders.datatable_templating_demo.update_failed") ||
          t("ui.orderStatusError"),
        confirmButtonText: t("orderDetails.alerts.ok") || t("ship.ok"),
      });
      return false;
    }
  };

  const handleOpenOrder = async (rowData, event) => {
    if (event?.preventDefault) {
      event.preventDefault();
    }

    if (!rowData?.id) {
      return;
    }

    if (isConfirmer && hasMultipleConfirmers) {
      if (
        rowData?.assignedConfirmerId &&
        rowData.assignedConfirmerId !== currentWorkerId
      ) {
        Swal.fire({
          icon: "warning",
          title:
            t("orders.datatable_templating_demo.warning") || t("Products.modalAdd.submitduplicateAlert"),
          text:
            t("orders.datatable_templating_demo.not_assigned_to_you") ||
            t("ui.assignedToOther"),
          confirmButtonText: t("orderDetails.alerts.ok") || t("ship.ok"),
        });
        return;
      }

      const isUnassignedOrder = !rowData?.assignedConfirmerId;

      if (isUnassignedOrder && hasPendingAssignedOrder(rowData.id)) {
        showPendingOrderAlert();
        return;
      }
    }
    navigateToOrder(rowData);
  };

  const assignmentBodyTemplate = (rowData) => {
    const assignedId = rowData?.assignedConfirmerId;
    const assignedName = rowData?.assignedConfirmerName;
    const isAssignedToSelf = assignedId && assignedId === currentWorkerId;

    if (!assignedId) {
      return (
        <button
          type="button"
          className="btn btn-outline-success"
          onClick={() => handleAssignToSelf(rowData)}
        >
          {t("actions.unlock")}
        </button>
      );
    }

    if (isAssignedToSelf) {
      return <span className="text-success">{t("insightads.datatable_templating_demo.assigned_to_you")}</span>;
    }

    return (
      <span className="text-muted">
        {t("insightads.datatable_templating_demo.assigned_to")} {assignedName || t("ui.otherConfirmer")}
      </span>
    );
  };

  const notPaidTemplate = (rowData) => {
    if (isConfirmer && hasMultipleConfirmers && !rowData?.assignedConfirmerId) {
      return (
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleAssignToSelf(rowData);
          }}
          style={{ cursor: "pointer", display: "inline-flex" }}
        >
          <img src="/locktouche.png" alt={t("ui.lock")} className="mx-auto" />
        </div>
      );
    }

    // Si confirmateur et assignée à un autre, ne rien afficher
    if (
      isConfirmer &&
      hasMultipleConfirmers &&
      rowData?.assignedConfirmerId &&
      rowData?.assignedConfirmerId !== currentWorkerId
    ) {
      return <span className="text-gray-400">-</span>;
    }

    const assignedId = rowData?.assignedConfirmerId;
    const assignedName = rowData?.assignedConfirmerName;
    const isAssignedToSelf = assignedId && assignedId === currentWorkerId;
    const canView = canViewPhoneForRow(rowData);

    return (
      <div>
        {hasMultipleConfirmers && isConfirmer ? (
          <>
            {!canView && !assignedId ? (
              <button
                type="button"
                className="btn btn-outline-success btn-sm"
                onClick={() => handleAssignToSelf(rowData)}
              >
                {t("actions.unlock")}
              </button>
            ) : isAssignedToSelf ? (
              shouldShowLockedContent(rowData) ? (
                <i className="fs-3" onClick={() => handlePay(rowData)}>
                  <img src={"/lock.png"} className="mx-auto" />
                </i>
              ) : (
                <PhoneActionMenu phone={rowData.phone} />
              )
            ) : assignedId && !isAssignedToSelf ? (
              <span className="text-muted text-sm">
                {t("insightads.datatable_templating_demo.assigned_to")} {assignedName || t("ui.otherConfirmer")}
              </span>
            ) : null}
          </>
        ) : (
          <>
            {shouldShowLockedContent(rowData) ? (
              <i className="fs-3" onClick={() => handlePay(rowData)}>
                <img src={"/lock.png"} className="mx-auto" />
              </i>
            ) : (
              <PhoneActionMenu phone={rowData.phone} />
            )}
          </>
        )}
      </div>
    );
  };

  const wilaya1 = (rowData) => {
    return (
      <div>{<a style={{ textDecoration: "none" }}>{rowData.state}</a>}</div>
    );
  };

  const imageBodyTemplate = (rowData) => {
    let productsToShow = [];
    const product = productdata.find(
      (product) => product.id === rowData.productId,
    );
    if (rowData.products && rowData.products.length > 0) {
      productsToShow = rowData.products
        .slice(0, 2)
        .map((p) => productdata.find((product) => product.id === p.id));
    }

    return rowData?.products ? (
      <div
        onClick={() => handleOpenOrder(rowData)}
        state={{
          from: { ...rowData },
          product: productdata.find(
            (product) => product.id === rowData.productId,
          ),
          products: productsToShow,
        }}
      >
        <div
          className={`flex overflow-hidden ${isRTL === "ltr"
              ? "-space-x-2 flex-row-reverse"
              : "-space-x-2 -space-x-reverse"
            }`}
        >
          {rowData.products.slice(0, 2).map((product, index) => (
            <div className="relative">
              {rowData.stayOffer && (
                <img
                  src="/sale.png"
                  alt={t("ui.sale")}
                  className="absolute top-0"
                  style={{
                    right: window.innerWidth <= 768 ? "31px" : "37px",
                    zIndex: 50,
                    maxWidth: window.innerWidth <= 768 ? "18px" : "20px",
                  }}
                />
              )}

              <div key={index} className="relative">
                <img
                  src={product?.image || "/product-foorweb.png"}
                  height="75px"
                  alt={product?.name}
                  className={`rounded-lg overflow-hidden shadow-sm border-2  w-14 h-14 bg-[#faf1ff] z-30 avatar${index + 1
                    }`}
                  style={{
                    border: rowData?.stayOffer
                      ? "2px solid #e91b24"
                      : rowData?.isImaginary
                        ? "2px solid #ffb400"
                        : "2px solid white",
                  }}
                />
              </div>

              {rowData.isImaginary && (
                <img
                  src="/euror.png"
                  alt="559384"
                  className="absolute bottom-0 "
                  style={{
                    right: window.innerWidth <= 768 ? "27px" : "32px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}
              {rowData.platform === "tiktok" && (
                <img
                  src="/tiktok.png" // حط لوجو تيك توك هنا
                  alt={t("navbar.try.tiktok")}
                  className="absolute top-0 right-0"
                  style={{
                    right: window.innerWidth <= 768 ? "0px" : "0px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}

              {rowData.platform === "foorchat" && (
                <img
                  src="/foorchat.gif" // حط لوجو تيك توك هنا
                  alt="foorchat"
                  className="absolute top-0 right-0"
                  style={{
                    right: window.innerWidth <= 768 ? "0px" : "0px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "40px" : "35px",
                  }}
                />
              )}

              {rowData.platform === "facebook" && (
                <img
                  src="/metaa.png" // حط لوجو ميتا/فيسبوك هنا
                  alt="Meta"
                  className="absolute top-0 left-0"
                  style={{
                    right: window.innerWidth <= 768 ? "0px" : "0px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}
            </div>
          ))}

          {rowData.products.length > 2 ? (
            <div className="relative">
              <div className="absolute top-0 left-0 text-white w-5 h-5 flex items-center justify-center rounded-full  bg-[#9b59bf] pt-1">
                {rowData.products.length > 2
                  ? `${rowData.products.length - 2}+`
                  : ""}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    ) : (
      <>
        {rowData.nameproduct ? (
          <Link
            to={`/orders/details`}
            state={{
              from: { ...rowData },
            }}
          >
            <div className="flex -space-x-2 overflow-hidden">
              <div className="relative">
                <img
                  src={rowData.image ? rowData.image : "/product-foorweb.png"}
                  height="75px"
                  alt={rowData.nameproduct ? rowData.nameproduct : ""}
                  className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                />
              </div>
            </div>
          </Link>
        ) : (
          <Link
            to={`/orders/details`}
            state={{
              from: { ...rowData },
              product: productdata.filter(
                (product) => product.id === rowData.productId,
              )[0],
              products: productdata,
            }}
          >
            <div className="flex -space-x-2 overflow-hidden">
              <div className="relative">
                <img
                  src={product ? product.image : "/product-foorweb.png"}
                  height="75px"
                  alt={product ? product.name : ""}
                  className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                />
              </div>
            </div>
          </Link>
        )}
      </>
    );
  };
  const hasValidOrders = selectedProducts.some((product) =>
    shouldShowLockedContent(product),
  );

  const [showOptions, setShowOptions] = useState(false);
  const handleButtonClick = () => {
    setShowOptions(!showOptions); // تغيير حالة الإظهار عند النقر
  };
  /*--------------------------------------- زر الحالات -----------------------------------------------*/
  const getUniqueDaysCount = (statusTimeline) => {
    if (!Array.isArray(statusTimeline)) return 0;

    const uniqueDates = new Set();

    statusTimeline.forEach((item) => {
      if (item.timestamp) {
        let timestamp = item.timestamp;

        // Validate timestamp and ensure it's a valid date
        if (timestamp.seconds) {
          timestamp = new Date(timestamp.seconds * 1000);
        } else if (isNaN(new Date(timestamp))) {
          return; // Skip invalid timestamp
        } else {
          timestamp = new Date(timestamp); // fallback
        }

        const dayString = timestamp.toISOString().split("T")[0]; // YYYY-MM-DD
        uniqueDates.add(dayString);
      }
    });

    return uniqueDates.size;
  };

  const checkAndUpdateStatusAtMidnight = async (order) => {
    // Vérifier si le nombre de tentatives est >= 3
    const tentativesCount = getUniqueDaysCount(order.statusTimeline);

    if (tentativesCount >= 3) {
      // Vérifier si c'est minuit (entre 00:00 et 00:01)
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();

      if (hours === 0 && minutes <= 1) {
        // Fenêtre de 1 minute après minuit
        // Vérifier si la dernière mise à jour n'a pas déjà été faite aujourd'hui
        const lastUpdate = order.lastStatusUpdate
          ? new Date(order.lastStatusUpdate.seconds * 1000)
          : null;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (!lastUpdate || lastUpdate < today) {
          const updatedData = {
            ...order,
            deleveryStatus: "6",
            lastStatusUpdate: new Date(),
            statusTimeline: [
              ...(order.statusTimeline || []),
              {
                status: "6",
                timestamp: new Date(),
                ownby: "Automatique",
              },
            ],
          };
          await workerAPI.updateOrder(order.id, updatedData);
        }
      }
    }
  };

  const combinedTemplate = (rowData) => {
    debugLog("combinedTemplate(render)", {
     rowId: rowData?.id,
      isValid: rowData?.isValid,
      typeofIsValid: typeof rowData?.isValid,
      deleveryStatus: rowData?.deleveryStatus,
      state: rowData?.state,
      commune: rowData?.commune,
      locked: shouldShowLockedContent(rowData),
    });

    // Si c'est un confirmateur et la commande n'est pas assignée à lui, afficher un message
    if (
      isConfirmer &&
      hasMultipleConfirmers &&
      rowData?.assignedConfirmerId &&
      rowData?.assignedConfirmerId !== currentWorkerId
    ) {
      return (
        <div className="px-3 py-2 bg-gray-100 dark:bg-[#262526] rounded-lg text-gray-500 dark:text-gray-400 text-sm text-center">
          {t("orders.datatable_templating_demo.not_assigned_to_you") ||
            t("ui.unassigned")}
        </div>
      );
    }


    if (isConfirmer && hasMultipleConfirmers && !rowData?.assignedConfirmerId) {
      return (
        <span
          className="
      inline-flex items-center gap-1
      px-2 py-0.5
      rounded-full
      bg-yellow-100 dark:bg-yellow-900/30
      text-yellow-700 dark:text-yellow-400
      text-xs font-medium
      whitespace-nowrap
    "
        >
          <span className="text-[10px]">⚠</span>
          {t("orders.datatable_templating_demo.must_assign_first") ||
            t("ui.assignFirst")}
        </span>
      );
    }

    const statusColor = statusBodyTemplate(rowData);
    const tentativesCount = getUniqueDaysCount(rowData.statusTimeline);
    let text = null;
    let buttonImage =
      "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"; // الصورة الافتراضية

    // DEBUG: verify why delivery options are hidden
    try {
      console.log("[DEBUG][combinedTemplate][delivery] rowData:", {
        id: rowData?.id,
        isValid: rowData?.isValid,
        deleveryStatus: rowData?.deleveryStatus,
        shouldShowLockedContent: shouldShowLockedContent(rowData),
        DC: rowData?.DC,
        statusTimeline: Array.isArray(rowData?.statusTimeline)
          ? rowData?.statusTimeline?.map((x) => x?.status)
          : null,
      });
    } catch (e) {
      // ignore
    }

    if (rowData.deleveryStatus === "1") {
      buttonImage = "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
    } else if (rowData.deleveryStatus === "2") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1688/1688988.png";
    } else if (rowData.deleveryStatus === "9") {
      buttonImage = "/8888205.png";
    } else if (rowData.deleveryStatus === "3") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8888/8888205.png";
    } else if (rowData.deleveryStatus === "4") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1559/1559859.png";
    } else if (rowData.deleveryStatus === "5") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/6815/6815043.png";
    } else if (
      rowData.deleveryStatus === "6" ||
      rowData.deleveryStatus === "6-3"
    ) {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/391/391247.png";
    } else if (rowData.deleveryStatus === "6-1") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/595/595067.png";
    } else if (rowData.deleveryStatus === "6-2") {
      buttonImage = "/order6-2.png";
    } else if (rowData.deleveryStatus === "11-1") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/2593/2593514.png";
    } else if (rowData.deleveryStatus === "11-2") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      // إذا تم اختيار إرسال إلى شركة الشحن
      if (rowData.DC === "1") {
        buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      }
    } else if (rowData.deleveryStatus === "11-3") {
      buttonImage = "../agenda.png";
    } else if (rowData.deleveryStatus === "11-4") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8402/8402548.png";
    } else if (rowData.deleveryStatus === "11-5") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/7787/7787073.png";
    } else if (rowData.deleveryStatus === "10") {
      buttonImage = "https://cdn-icons-png.flaticon.com/512/11153/11153363.png";
    }

    const shippingOptions = [];
    if (!!store.Maystro) shippingOptions.push({ value: "1", label: "Maystro" });
    if (!!store.Zrexpress)
      shippingOptions.push({ value: "2", label: "Zr express" });
    if (!!store.Ecotrack && !!store.Uecotrack)
      shippingOptions.push({ value: "3", label: "Ecotrack" });
    if (!!store.Userguid && !!store.ApitokenNord)
      shippingOptions.push({ value: "4", label: "Nord Et Ouest" });
    if (!!store.YalidineW && !!store.Yalidinetoken && !!store.Yalidineid)
      shippingOptions.push({ value: "5", label: "Yalidine" });
    if (!!store.UserguidGuepex && !!store.Apitokenguepex)
      shippingOptions.push({ value: "6", label: "Guepex" });
    if (!!store.apielogistia)
      shippingOptions.push({ value: "7", label: "elogistia" });
    if (!!store.zimouToken)
      shippingOptions.push({ value: "8", label: "zimou Express" });
    if (!!store.AmeexId) shippingOptions.push({ value: "9", label: "Ameex" });
    if (!!store.mdm_apikey)
      shippingOptions.push({ value: "10", label: "MDM Express" });
    if (!!store.YalitecId)
      shippingOptions.push({ value: "11", label: "Yalitec" });
    if (!!store.coliv_token)
      shippingOptions.push({ value: "12", label: "Colvraison" });
    if (!!store.mylerzToken)
      shippingOptions.push({ value: "13", label: "Mylerz" });
    if (!!store.ecomdelivery_token)
      shippingOptions.push({ value: "14", label: "Ecom Delivery" });
   if (
  !!store.ecomdeliveryv2_key &&
  !!store.ecomdeliveryv2_token
) {
  shippingOptions.push({
    value: "18",
    label: "Ecom Delivery V2",
  });
}
    if (!!store.flashdelivery_key)
      shippingOptions.push({ value: "16", label: "Flash Delivery" });
    if (!!store.zrExpressXTenant_V2)
      shippingOptions.push({ value: "17", label: "Zr Express V2" });
    // if (!!store.Zrexpress) shippingOptions.push({ value: "8", label: "3Mexpress" });

    return (
      <Dropdown
        overlay={
          <Menu className="dark:bg-[#141414] dark:!text-gray-300 dark:!border-[#3c3a3d]">
            {rowData.deleveryStatus !== "5" && (
              <>
                <Menu.Item
                  key="3"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-cart-check dark:!text-gray-300  ${rowData.deleveryStatus === "3" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "3")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.confirmed")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                {store.confirmChat && (
                  <Menu.Item
                    key="9"
                    className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-cart-check dark:!text-gray-300 ${rowData.deleveryStatus === "9" ? "selected" : ""
                      }`}
                    onClick={() => changeStatus(rowData, "9")}
                  >
                    <a className="s11 dark:!text-gray-300">
                      {t(
                        "orders.datatable_templating_demo.confirmed_by_customer",
                      )}
                    </a>
                  </Menu.Item>
                )}
                {store.confirmChat && <hr className="m-0 p-0" />}
                <Menu.Item
                  key="11-2"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-telephone-x-fill dark:!text-gray-300 ${rowData.deleveryStatus === "11-2" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "11-2")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.no_response_to_call")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-3"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-calendar2-check dark:!text-gray-300${rowData.deleveryStatus === "11-3" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "11-3")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.postponed")}
                  </a>
                </Menu.Item>

                <hr className="m-0 p-0" />
                <Menu.Item
                  key="6"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-x-circle dark:!text-gray-300 ${rowData.deleveryStatus === "6" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "6")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.cancelled")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />

                <Menu.Item
                  key="6-1"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-exclamation-circle dark:!text-gray-300 ${rowData.deleveryStatus === "6-1" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "6-1")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.fake")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />

                <Menu.Item
                  key="6-2"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-files dark:!text-gray-300 ${rowData.deleveryStatus === "6-2" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "6-2")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.duplicate")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />

                <Menu.Item
                  key="11-5"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-person-x dark:!text-gray-300 ${rowData.deleveryStatus === "11-5" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "11-5")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t(
                      "orders.datatable_templating_demo.cancelled_by_customer",
                    )}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-1"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-telephone-inbound dark:!text-gray-300 ${rowData.deleveryStatus === "11-1" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "11-1")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t(
                      "orders.datatable_templating_demo.awaiting_customer_contact",
                    )}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-4"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-telephone-minus dark:!text-gray-300 ${rowData.deleveryStatus === "11-4" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "11-4")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.line_busy")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="4"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-truck dark:!text-gray-300 ${rowData.deleveryStatus === "4" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "4")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t(
                      "orders.datatable_templating_demo.with_delivery_company",
                    )}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />

                <Menu.Item
                  key="4"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-arrow-return-right dark:!text-gray-300 ${rowData.deleveryStatus === "10" ? "selected" : ""
                    }`}
                  onClick={() => changeStatus(rowData, "10")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.returned")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                {/* إضافة باقي العناصر هنا */}
              </>
            )}
            <Menu.Item
              key="5"
              className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-check-circle dark:!text-gray-300 ${rowData.deleveryStatus === "5" ? "selected" : ""
                }`}
              onClick={() => changeStatus(rowData, "5")}
            >
              <a className="s11 dark:!text-gray-300">
                {t("orders.datatable_templating_demo.completed")}
              </a>
            </Menu.Item>

            {shippingOptions.length > 0 && (
              <>
                <hr className="m-0 p-0" />
                {shouldShowLockedContent(rowData) ? (
                  <Menu.Item
                    key="locked"
                    disabled
                    className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-lock dark:!text-gray-300"
                  >
                    <span className="s11 dark:!text-gray-300">
                      {t("orders.datatable_templating_demo.locked") ||
                        t("ui.lockedContent")}
                      {" - "}
                      {t("ui.cannotUploadOrder")}
                    </span>
                  </Menu.Item>
                ) : (
                  shippingOptions.map((option) => (
                    <Menu.Item
                      key={option.value}
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-truck dark:!text-gray-300 ${rowData.DC === option.value ? "selected" : ""
                        }`}
                      onClick={async () => {
                        const isOnline = navigator.onLine;
                        if (!isOnline) {
                          Swal.fire({
                            icon: "error",
                            title:
                              t("orders.datatable_templating_demo.error") ||
                              t("error"),
                            text: t("ship.no_internet"),
                            confirmButtonText:
                              t("orders.datatable_templating_demo.okay") || t("ship.ok"),
                          });
                          return;
                        }

                        Swal.fire({
                          title: t("Products.Table.sendingAllToEcomanager"),
                          allowOutsideClick: false,
                          allowEscapeKey: false,
                          didOpen: () => {
                            Swal.showLoading();
                          },
                        });

                        try {
                          await changeShip(rowData, option.value);
                          Swal.close();
                          Swal.fire({
                            icon: "success",
                            title: t("ui.orderSent"),
                            text: t("ui.sentToCarrier"),
                            confirmButtonText:
                              t("orders.datatable_templating_demo.okay") || t("ship.ok"),
                            confirmButtonColor: "#7e5395",
                          });
                        } catch (e) {
                          Swal.close();
                          const msg =
                            e?.message ||
                            errorMessage ||
                            "حدث خطأ أثناء الإرسال. حاول مرة أخرى.";
                          Swal.fire({
                            icon: "error",
                            title: t("ui.sendOrderFailed"),
                            text: String(msg),
                            confirmButtonText:
                              t("orders.datatable_templating_demo.okay") || t("ship.ok"),
                            confirmButtonColor: "#9e68ba",
                          });
                        }
                      }}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t(
                          "orders.datatable_templating_demo.upload_to_delivery_company",
                        )}{" "}
                        {option.label}
                      </a>
                    </Menu.Item>
                  ))
                )}
              </>
            )}
          </Menu>
        }
      >
        <div className="relative inline-block dark:!bg-[#181919]">
          <button className="flex items-center dark:!bg-[#181919] justify-center px-4 py-2.5 rounded-lg border border-gray-300 dark:!border-[#3c3a3d] bg-white hover:bg-gray-100 active:bg-gray-200 transition duration-150 mx-auto">
            {text == null ? (
              <img
                src={buttonImage}
                alt={t("ui.buttonIcon")}
                style={{ width: "20px" }}
              />
            ) : (
              <span className="text-sm font-medium text-gray-800">{text}</span>
            )}
          </button>

          {tentativesCount > 0 && (
            <span className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center text-xs font-bold text-white bg-[#5a2b73] rounded-full shadow-md">
              {tentativesCount}
            </span>
          )}
        </div>
      </Dropdown>
    );
  };

  // Composant React affichant un bouton de suivi d'expédition avec une pop-up du statut de suivi.
  const trackship = (data) => {
    const [showPopup, setShowPopup] = React.useState(false);
    const buttonImage = "https://cdn-icons-png.flaticon.com/512/609/609361.png";

    const [isOpen, setIsOpen] = useState(false);
    const formatStatus = (status) => {
      return status
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    const handlePopup = (e) => {
      e.preventDefault();
      setShowPopup(!showPopup);
    };

    return (
      <div className="relative">
        {shouldShowLockedContent(data) ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{t("ship.send_tracking_link")}</Tooltip>}
          >
            <button
              className="flex dark:!bg-[#181919] dark:!border-[#3c3a3d] items-center justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] transition-colors active:bg-[#faf1ff] bot mx-auto"
              disabled
              onClick={handlePopup}
            >
              <img
                src={buttonImage}
                style={{ width: "20px" }}
                alt={t("ui.buttonIcon")}
              />
            </button>
          </OverlayTrigger>
        ) : (
          <div>
            <button
              className="flex items-center dark:!bg-[#181919] dark:!border-[#3c3a3d] justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] transition-colors active:bg-[#faf1ff] bot mx-auto"
              onClick={() => {
                const trackingStatus = data.tracking_status;
                if (trackingStatus) {
                  setIsOpen(true);
                }
                // alert(JSON.stringify(trackingStatus));
              }}
              onMouseEnter={handlePopup}
              onMouseLeave={handlePopup}
            >
              <img
                src={buttonImage}
                style={{ width: "20px" }}
                alt={t("ui.buttonIcon")}
              />
            </button>
          </div>
        )}

        {showPopup && (
          <div className="absolute z-10 p-2 mt-1 text-sm bg-white border rounded-lg  -right-4">
            {data.tracking_status ? (
              <p>
                {data.tracking_status[data.tracking_status.length - 1].status}
              </p>
            ) : (
              // <ul className="space-y-1">
              //   {data.tracking_status.map((status, index) => (
              //     <li key={index}>{status}</li>
              //   ))}
              // </ul>
              <p>{t("ship.no_tracking_number")}</p>
            )}
          </div>
        )}
      </div>
    );
  };

  const shippingOptions = [];
  if (!!store.Maystro) shippingOptions.push({ value: "1", label: "Maystro" });
  if (!!store.Zrexpress)
    shippingOptions.push({ value: "2", label: "Zr express" });
  if (!!store.Ecotrack && !!store.Uecotrack)
    shippingOptions.push({ value: "3", label: "Ecotrack" });
  if (!!store.Userguid && !!store.ApitokenNord)
    shippingOptions.push({ value: "4", label: "Nord Et Ouest" });
  if (!!store.YalidineW && !!store.Yalidinetoken && !!store.Yalidineid)
    shippingOptions.push({ value: "5", label: "Yalidine" });
  if (!!store.UserguidGuepex && !!store.Apitokenguepex)
    shippingOptions.push({ value: "6", label: "Guepex" });
  if (!!store.apielogistia)
    shippingOptions.push({ value: "7", label: "elogistia" });
  if (!!store.ZimouToken)
    shippingOptions.push({ value: "8", label: "zimou Express" });
  if (!!store.AmeexId) shippingOptions.push({ value: "9", label: "Ameex" });
  if (!!store.mdm_apikey)
    shippingOptions.push({ value: "10", label: "MDM Express" });
  if (!!store.YalitecId)
    shippingOptions.push({ value: "11", label: "Yalitec" });
  if (!!store.coliv_token)
    shippingOptions.push({ value: "12", label: "Colvraison" });
  if (!!store.mylerzToken)
    shippingOptions.push({ value: "13", label: "Mylerz" });
  if (!!store.ecomdelivery_token)
    shippingOptions.push({ value: "14", label: "Ecom Delivery" });
   if (
  !!store.ecomdeliveryv2_key &&
  !!store.ecomdeliveryv2_token
) {
  shippingOptions.push({
    value: "18",
    label: "Ecom Delivery V2",
  });
}
  if (!!store.flashdelivery_key)
    shippingOptions.push({ value: "16", label: "Flash Delivery" });
  if (!!store.zrExpressXTenant_V2)
    shippingOptions.push({ value: "17", label: "Zr Express V2" });
  const darkModeStyles = `
  /* Styles pour le mode sombre du DataTable */
  .dark .p-datatable .p-datatable-thead > tr > th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
    border-left: 1px solid #1e1e1e !important;
    border-right: 1px solid #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
    background-color: #181919 !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr > td {
    border-color: #3c3a3d !important;
    color: #d1d5db !important;
  }


  /* Pour les bordures du tableau */
  .dark .p-datatable {
    border-color: #3c3a3d !important;
  }

  /* Pour les éléments expandables */
  .dark .p-datatable .p-row-expansion {
    background-color: #141414 !important;
    color: #d1d5db !important;
  }
`;

  return (
    <div className="datatable-templating-demo">
      {/* Order Actions Toolbar */}
      <div className="bg-white dark:!bg-[#181919] rounded-t-xl p-4 border-y border-purple-100 dark:!border-[#3c3a3d]">
        <div className="flex flex-wrap items-center gap-3">
          {/* Selected Orders Label */}
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-700 ml-2 dark:text-gray-300">
              {t("orders.datatable_templating_demo.selected_orders")}:
            </span>
            <span className="bg-[#faf1ff] dark:bg-[#181919] text-[#9e68ba] px-2 py-0.5 rounded-md font-medium text-sm">
              {selectedProducts.length}
            </span>
          </div>

          {/* CSV Export Button */}
          <button
            disabled={selectedProducts.length < 1}
            className={`p-2 bg-white dark:!bg-[#141414] border ${selectedProducts.length < 1
                ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
              } rounded-lg transition-colors flex items-center gap-2`}
          >
            <CSVLink
              data={selectedProducts.map((p) => {
                const productOptions =
                  p.products && p.products[0] && p.products[0].options;

                return {
                  index: p.index,
                  name: p.name,
                  phone: shouldShowLockedContent(p) ? "***" : p.phone,
                  state: p.state,
                  commune: p.commune,
                  address: p.address,
                  product: p.nameproduct || "منتج غير موجود",
                  qty: p.qty,
                  deleveryPrice: p.deleveryPrice,
                  total: p.total,
                  sku: p.sku,
                  options: productOptions
                    ? `Size: ${productOptions.size ||
                    t("orders.datatable_templating_demo.undefined")
                    }, Color: ${productOptions.color ||
                    t("orders.datatable_templating_demo.undefined")
                    }, Offer: ${productOptions.offer ||
                    t("orders.datatable_templating_demo.undefined")
                    }`
                    : "لا توجد خيارات",
                };
              })}
              filename={generateFileName()}
              className={
                selectedProducts.length < 1 ? "pointer-events-none" : ""
              }
            >
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`${selectedProducts.length < 1
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                    }`}
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <span
                  className={`${selectedProducts.length < 1
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                    } text-sm font-medium`}
                >
                  {t("orders.datatable_templating_demo.export")}
                </span>
              </div>
            </CSVLink>
          </button>
          <iframe
            id="pdfPrinter"
            style={{ display: "none" }}
            title={t("ui.printPdf")}
          />

          {/* Print Button */}
          <button
            disabled={selectedProducts.length < 1}
            onClick={handleLabels}
            className={`p-2 bg-white border dark:!bg-[#141414] ${selectedProducts.length < 1
                ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
              } rounded-lg transition-colors flex items-center gap-2`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`${selectedProducts.length < 1 ? "text-gray-400" : "text-[#9e68ba]"
                }`}
            >
              <polyline points="6 9 6 2 18 2 18 9" />
              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
              <rect x="6" y="14" width="12" height="8" />
            </svg>
            <span
              className={`${selectedProducts.length < 1 ? "text-gray-400" : "text-[#9e68ba]"
                } text-sm font-medium`}
            >
              {t("orders.datatable_templating_demo.print")}
            </span>
          </button>
          <GoogleSheetButtons
            selectedProducts={selectedProducts}
            t={t}
            store={store}
            showOnlyV3={true}
          />
          {/* Shipping Dropdown */}

          <div className="relative">
            <Dropdown
              disabled={selectedProducts.length < 1 || hasValidOrders}
              overlay={
            <Menu className="bg-white dark:bg-[#141414] rounded-lg shadow-lg border border-purple-100 dark:!border-[#3c3a3d] py-1 min-w-[200px]">
                {/* debug marker */}
                {/* eslint-disable-next-line no-unused-vars */}
                {(() => {
                  debugLog("delivery dropdown disabled check", {
                    selectedCount: selectedProducts?.length || 0,
                    hasValidOrders,
                    selectedIds: selectedProducts?.map((o) => o?.id),
                    selectedLockedIds: selectedProducts
                      ?.filter((o) => shouldShowLockedContent(o))
                      ?.map((o) => o?.id),
                  });
                  return null;
                })()}
                  {shippingOptions.length > 0 && (
                    <>
                      <div>
                        <Menu>
                          {shippingOptions.map((item) => (
                            <Menu.Item
                              key={item.value}
                              className="hover:bg-purple-50 transition-colors"
                              onClick={() => {
                                setDeleveryCompany(item.value);
                              }}
                            >
                              <a className="px-4 py-2 block text-sm text-gray-700 hover:text-[#9e68ba]">
                                <span className="flex items-center">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="ml-2 text-[#9e68ba]"
                                  >
                                    <rect x="1" y="3" width="15" height="13" />
                                    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                                    <circle cx="5.5" cy="18.5" r="2.5" />
                                    <circle cx="18.5" cy="18.5" r="2.5" />
                                  </svg>
                                  {t("ui.uploadTo")} {item.label}
                                </span>
                              </a>
                            </Menu.Item>
                          ))}
                        </Menu>
                        <Input
                          style={{ display: "none" }}
                          value={deleveryCompany}
                          onChange={(e) => setDeleveryCompany(e.target.value)}
                        />
                      </div>
                    </>
                  )}
                </Menu>
              }
            >
              <button
                disabled={selectedProducts.length < 1 || hasValidOrders}
                className={`p-2 bg-white dark:!bg-[#141414]  border ${selectedProducts.length < 1 || hasValidOrders
                    ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                    : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
                  } rounded-lg transition-colors flex items-center gap-2`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`${selectedProducts.length < 1 || hasValidOrders
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                    }`}
                >
                  <rect x="1" y="3" width="15" height="13" />
                  <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                  <circle cx="5.5" cy="18.5" r="2.5" />
                  <circle cx="18.5" cy="18.5" r="2.5" />
                </svg>
                <span
                  className={`${selectedProducts.length < 1 || hasValidOrders
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                    } text-sm font-medium`}
                >
                  {t("orders.datatable_templating_demo.delivery")}
                  {hasValidOrders}
                </span>
              </button>
            </Dropdown>
          </div>

          {/* Order Status Dropdown */}
          <select
            disabled={selectedProducts.length < 1}
            className={`p-2 bg-white border dark:!bg-[#141414] ${selectedProducts.length < 1
                ? "border-gray-200 opacity-50 cursor-not-allowed dark:!border-[#3c3a3d] "
                : "border-purple-200 hover:bg-purple-50 dark:!border-[#3c3a3d] dark:text-gray-300"
              } rounded-lg text-sm ${selectedProducts.length < 1 ? "text-gray-400" : "text-gray-700 "
              } focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent`}
            required
            value={bluck}
            onChange={(e) => {
              setBluck(e.target.value);
            }}
          >
            <option value="">
              {t("orders.datatable_templating_demo.change_order_status")}
            </option>
            <option className="dark:text-gray-300" value="3">
              {t("orders.datatable_templating_demo.confirmed")}
            </option>
            <option className="dark:text-gray-300" value="11-2">
              {t("orders.datatable_templating_demo.no_response_to_call")}
            </option>
            <option className="dark:text-gray-300" value="11-3">
              {t("orders.datatable_templating_demo.postponed")}
            </option>
            <option className="dark:text-gray-300" value="6">
              {t("orders.datatable_templating_demo.cancelled")}
            </option>
            <option className="dark:text-gray-300" value="6-1">
              {t("orders.datatable_templating_demo.fake")}
            </option>
            <option className="dark:text-gray-300" value="6-2">
              {t("orders.datatable_templating_demo.duplicate")}
            </option>
            <option className="dark:text-gray-300" value="11-5">
              {t("orders.datatable_templating_demo.cancelled_by_customer")}
            </option>
            <option className="dark:text-gray-300" value="11-6">
              {t("orders.datatable_templating_demo.awaiting_customer_contact")}
            </option>
            <option className="dark:text-gray-300" value="11-4">
              {t("orders.datatable_templating_demo.line_busy")}
            </option>
            <option className="dark:text-gray-300" value="4">
              {t("orders.datatable_templating_demo.with_delivery_company")}
            </option>
            <option className="dark:text-gray-300" value="5">
              {t("orders.datatable_templating_demo.completed")}
            </option>
            <option className="dark:text-gray-300" value="7">
              {t("orders.datatable_templating_demo.delete")}
            </option>
          </select>

          {/* Apply Button */}
          <button
            disabled={
              selectedProducts.length < 1 ||
              (bluck === "" && deleveryCompany === "")
            }
            onClick={groubeUpdates}
            className={`py-2 px-4 rounded-lg text-sm font-medium dark:!bg-[#141414] border dark:!border-[#3c3a3d] ${selectedProducts.length < 1 ||
                (bluck === "" && deleveryCompany === "")
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-[#9b59bf] hover:bg-[#814a9f] dark:!text-[#9e68ba] text-white"
              } transition-colors`}
          >
            {t("orders.datatable_templating_demo.process_action")}
          </button>
        </div>
      </div>
      <div className=" dark:bg-gray-900">
        <style>{darkModeStyles}</style>
        <DataTable
          value={
            !!filter
              ? orders.filter(
                (order) =>
                  order.index
                    .toString()
                    .toLowerCase()
                    .includes(filter.toLowerCase()) ||
                  order.name.toLowerCase().includes(filter.toLowerCase()) ||
                  order.phone.toLowerCase().includes(filter.toLowerCase()),
              )
              : _DATA.currentData()
          }
          responsiveLayout="scroll"
          rowExpansionTemplate={rowExpansionTemplate}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          emptyMessage={t("ship.no_results_found")}
          rowClassName={(rowData, rowIndex) =>
            rowIndex % 2 === 0
              ? "p-row-odd dark:!bg-[#1e1e1e]"
              : "p-row-even dark:!bg-[#181919]"
          }
          className="dark:!bg-[#181919] dark:text-gray-300"
        >
          <Column
            header={
            <Form.Check
              type={"checkbox"}
              checked={selectedProducts.length === _DATA.currentData().length}
              onChange={() => {
                const next =
                  selectedProducts.length === _DATA.currentData().length
                    ? []
                    : [..._DATA.currentData()];

                debugLog("header checkbox onChange", {
                  nextCount: next?.length,
                  nextFirst: next?.[0]
                    ? {
                        id: next[0].id,
                        isValid: next[0].isValid,
                        typeofIsValid: typeof next[0].isValid,
                        deleveryStatus: next[0].deleveryStatus,
                      }
                    : null,
                });

                setSelectedProducts(next);
              }}
              className="dark:bg-gray-700 dark:border-gray-600"
            />
            }
            className="text-end dark:!bg-[#181919] dark:!text-gray-300"
            body={selectTemplate}
            style={{ width: "3rem" }}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          />

          <Column
            header={t("orders.datatable_templating_demo.product")}
            className="text-end dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            body={imageBodyTemplate}
          />

          <Column
            body={customerName}
            field="name"
            className="text-end n-name dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            header={t("orders.datatable_templating_demo.customer")}
          />

          <Column
            field={notPaidTemplate}
            className="text-end n-phone dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            header={t("orders.datatable_templating_demo.phone_number")}
          />

          <Column
            body={dateBodyTemplate}
            className="text-end n-date dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            header={t("orders.datatable_templating_demo.order_date")}
          />

          <Column
            field={wilaya1}
            className="text-end n-wilaya dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            header={
              store.country === "الجزائر"
                ? t("orders.datatable_templating_demo.wilaya")
                : store.country === "مصر"
                  ? t("orders.datatable_templating_demo.wilaya_eg")
                  : t("ship.wilaya")
            }
          />

          {canEditOrders && (
            <Column
              style={{ minwidth: "125px" }}
              header={t("orders.datatable_templating_demo.order_status")}
              className="text-end n-status1 dark:!bg-[#181919] dark:!text-gray-300"
              headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
              body={combinedTemplate}
            />
          )}

          {/* {store.trackshipactive && (
            <Column
              style={{ minWidth: "125px" }}
              header="trackship"
              className="text-end n-status1 dark:!bg-[#181919] dark:!text-gray-300"
              headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
              body={trackship}
            />
          )} */}

          <Column
            style={{ color: "#6e4881" }}
            body={orderTotal}
            className="text-end n-total dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            header={t("orders.datatable_templating_demo.total")}
          />

          {canEditOrders && (
            <Column
              header=""
              className="text-end n-delet dark:!bg-[#181919] dark:!text-gray-300"
              headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
              body={actionTemplate}
            />
          )}

          <Column
            expander
            style={{ width: "0em" }}
            className="dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          />
        </DataTable>
      </div>

      <div className="d-flex justify-content-center py-3 dark:!bg-[#181919]">
        {
          <Stack spacing={2} dir="ltr">
            <Pagination
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
              color="secondary"
              sx={{
                backgroundColor: isDark ? "#181919" : "#ffffff",
                borderRadius: 2,
                p: 2,
                "& .MuiPaginationItem-root": {
                  color: isDark ? "#e1cfff" : "#000000",
                  borderColor: isDark ? "#a065c0" : "#ccc",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: isDark ? "#9b59bf" : "#9b59bf",
                  color: "#fff",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: isDark ? "#7c3aad" : "#f0f0f0",
                },
              }}
            />
          </Stack>
        }
      </div>
      <DeskModal
        isOpen={noestModalOpen}
        onClose={handleNoestModalClose}
        onSelect={(deskCode) => {
          setNoestSelectedDeskCode(deskCode);
          setNoestModalOpen(false);
        }}
        data={noestPendingData}
        isMultiple={isMultiple}
        onCloseMultiple={handleNoestModalClose}
        onSelectMultiple={handleNoestDeskSelected}
        apiEndpoint="https://app.noest-dz.com/api/public/desks"
        apiToken={store.ApitokenNord}
        userGuid={store.Userguid}
        companyName="Nord & Ouest"
        companyType="noest"
      />

      <DeskModal
        isOpen={yalidineModalOpen}
        onClose={handleYalidineModalClose}
        onSelect={(deskCode) => {
          setYalidineSelectedDeskCode(deskCode);
          setYalidineModalOpen(false);
        }}
        data={yalidinePendingData}
        isMultiple={isMultiple}
        onCloseMultiple={handleYalidineModalClose}
        onSelectMultiple={handleYalidineDeskSelected}
        apiEndpoint="https://backend.foorweb.shop/api/yalidine/centers"
        apiToken={store.ApitokenYalidine}
        userGuid={store.Userguid}
        companyName="Yalidine"
        companyType="yalidine"
      />

      <div className="hidden">
        <ComponentToPrint
          ref={componentRef}
          data={selectedProducts}
          store={store}
          account={account}
          products={productdata}
        />
      </div>
    </div>
  );
};

export default DataTableTemplatingDemo;
